/**
 * API 权限常量
 * 
 * ⚠️ 此文件由脚本自动生成，请勿手动修改
 * 
 * @author YSFL Team
 * @date 2026-09-24
 * @generated php artisan permissions:export
 */

// ==================== ANDON ====================

/** BINDING 权限 */
/** 设备绑定 - 查看 */
export const PERM_ANDON_BINDING_VIEW = 'andon:binding:view' as const;

/** 设备绑定 - 创建 */
export const PERM_ANDON_BINDING_CREATE = 'andon:binding:create' as const;

/** 设备绑定 - 更新 */
export const PERM_ANDON_BINDING_UPDATE = 'andon:binding:update' as const;

/** 设备绑定 - 删除 */
export const PERM_ANDON_BINDING_DELETE = 'andon:binding:delete' as const;

/** CALL 权限 */
/** 发起呼叫 */
export const PERM_ANDON_CALL_CREATE = 'andon:call:create' as const;

/** 安灯呼叫 - 查看 */
export const PERM_ANDON_CALL_VIEW = 'andon:call:view' as const;

/** 响应呼叫 */
export const PERM_ANDON_CALL_RESPOND = 'andon:call:respond' as const;

/** 关闭呼叫 */
export const PERM_ANDON_CALL_COMPLETE = 'andon:call:complete' as const;

/** 取消呼叫 */
export const PERM_ANDON_CALL_CANCEL = 'andon:call:cancel' as const;

/** CALL-TYPE 权限 */
/** Call-type - 查看 */
export const PERM_ANDON_CALL_TYPE_VIEW = 'andon:call-type:view' as const;

/** Call-type - 创建 */
export const PERM_ANDON_CALL_TYPE_CREATE = 'andon:call-type:create' as const;

/** Call-type - 更新 */
export const PERM_ANDON_CALL_TYPE_UPDATE = 'andon:call-type:update' as const;

/** Call-type - 删除 */
export const PERM_ANDON_CALL_TYPE_DELETE = 'andon:call-type:delete' as const;

/** Notification-config - 呼叫接收人配置 - 查看 */
export const PERM_ANDON_NOTIFICATION_CONFIG_VIEW = 'andon:notification-config:view' as const;

/** Notification-config - 呼叫接收人配置 - 更新 */
export const PERM_ANDON_NOTIFICATION_CONFIG_UPDATE = 'andon:notification-config:update' as const;

/** DEVICE 权限 */
/** 安灯设备 - 查看 */
export const PERM_ANDON_DEVICE_VIEW = 'andon:device:view' as const;

/** 安灯设备 - 创建 */
export const PERM_ANDON_DEVICE_CREATE = 'andon:device:create' as const;

/** 安灯设备 - 更新 */
export const PERM_ANDON_DEVICE_UPDATE = 'andon:device:update' as const;

/** 安灯设备 - 删除 */
export const PERM_ANDON_DEVICE_DELETE = 'andon:device:delete' as const;

/** STATISTICS 权限 */
/** 统计分析 - 查看 */
export const PERM_ANDON_STATISTICS_VIEW = 'andon:statistics:view' as const;

/** 统计分析 - 导出 */
export const PERM_ANDON_STATISTICS_EXPORT = 'andon:statistics:export' as const;


// ==================== APP-LOGS ====================

/** FUNNEL 权限 */
/** 查看漏斗分析 */
export const PERM_APP_LOGS_FUNNEL_VIEW = 'app-logs:funnel:view' as const;

/** 创建漏斗定义 */
export const PERM_APP_LOGS_FUNNEL_CREATE = 'app-logs:funnel:create' as const;

/** 更新漏斗定义 */
export const PERM_APP_LOGS_FUNNEL_UPDATE = 'app-logs:funnel:update' as const;

/** 删除漏斗定义 */
export const PERM_APP_LOGS_FUNNEL_DELETE = 'app-logs:funnel:delete' as const;

/** PERFORMANCE-LOG 权限 */
/** 查看性能日志 */
export const PERM_APP_LOGS_PERFORMANCE_LOG_VIEW = 'app-logs:performance-log:view' as const;

/** 查看错误日志 */
export const PERM_APP_LOGS_ERROR_LOG_VIEW = 'app-logs:error-log:view' as const;

/** 查看行为日志 */
export const PERM_APP_LOGS_JOURNEY_LOG_VIEW = 'app-logs:journey-log:view' as const;

/** ALERT 权限 */
/** 查看监控告警 */
export const PERM_APP_LOGS_ALERT_VIEW = 'app-logs:alert:view' as const;

/** 处理监控告警 */
export const PERM_APP_LOGS_ALERT_HANDLE = 'app-logs:alert:handle' as const;


// ==================== BOM ====================

/** BOM 权限 */
/** BOM管理 - 查看 */
export const PERM_BOM_BOM_VIEW = 'bom:bom:view' as const;

/** 创建BOM */
export const PERM_BOM_BOM_CREATE = 'bom:bom:create' as const;

/** 修改BOM */
export const PERM_BOM_BOM_UPDATE = 'bom:bom:update' as const;

/** 删除BOM */
export const PERM_BOM_BOM_DELETE = 'bom:bom:delete' as const;

/** BOM管理 - 审批 */
export const PERM_BOM_BOM_APPROVE = 'bom:bom:approve' as const;

/** 冻结BOM */
export const PERM_BOM_BOM_FREEZE = 'bom:bom:freeze' as const;

/** 作废BOM */
export const PERM_BOM_BOM_OBSOLETE = 'bom:bom:obsolete' as const;

/** BOM管理 - 导入 */
export const PERM_BOM_BOM_IMPORT = 'bom:bom:import' as const;

/** SUBSTITUTE-MATERIAL 权限 */
/** 替代料管理 - 查看 */
export const PERM_BOM_SUBSTITUTE_MATERIAL_VIEW = 'bom:substitute-material:view' as const;

/** 替代料管理 - 创建 */
export const PERM_BOM_SUBSTITUTE_MATERIAL_CREATE = 'bom:substitute-material:create' as const;

/** 替代料管理 - 更新 */
export const PERM_BOM_SUBSTITUTE_MATERIAL_UPDATE = 'bom:substitute-material:update' as const;

/** 替代料管理 - 删除 */
export const PERM_BOM_SUBSTITUTE_MATERIAL_DELETE = 'bom:substitute-material:delete' as const;


// ==================== DINGTALK ====================

/** AUTH 权限 */
/** 钉钉 - 获取免登配置 */
export const PERM_DINGTALK_AUTH_CONFIG = 'dingtalk:auth:config' as const;

/** 钉钉 - H5/小程序免登 */
export const PERM_DINGTALK_AUTH_LOGIN = 'dingtalk:auth:login' as const;

/** ORGANIZATION 权限 */
/** 钉钉 - 同步组织架构 */
export const PERM_DINGTALK_ORGANIZATION_SYNC = 'dingtalk:organization:sync' as const;


// ==================== EMPLOYEE ====================

/** EMPLOYEE 权限 */
/** 员工管理 - 查看 */
export const PERM_EMPLOYEE_EMPLOYEE_VIEW = 'employee:employee:view' as const;

/** 新增员工 */
export const PERM_EMPLOYEE_EMPLOYEE_CREATE = 'employee:employee:create' as const;

/** 修改员工信息 */
export const PERM_EMPLOYEE_EMPLOYEE_UPDATE = 'employee:employee:update' as const;

/** 删除员工 */
export const PERM_EMPLOYEE_EMPLOYEE_DELETE = 'employee:employee:delete' as const;

/** 员工管理 - 企业微信同步 */
export const PERM_EMPLOYEE_EMPLOYEE_SYNC = 'employee:employee:sync' as const;

/** 员工管理 - 黑名单查看 */
export const PERM_EMPLOYEE_EMPLOYEE_BLACKLIST = 'employee:employee:blacklist' as const;

/** 员工管理 - 离职 */
export const PERM_EMPLOYEE_EMPLOYEE_RESIGN = 'employee:employee:resign' as const;

/** 员工管理 - 转正 */
export const PERM_EMPLOYEE_EMPLOYEE_REGULARIZE = 'employee:employee:regularize' as const;

/** 员工管理 - 关联系统账号 */
export const PERM_EMPLOYEE_EMPLOYEE_LINK_USER = 'employee:employee:link-user' as const;

/** 员工管理 - 解除系统账号关联 */
export const PERM_EMPLOYEE_EMPLOYEE_UNLINK_USER = 'employee:employee:unlink-user' as const;

/** 员工管理 - 发送账号密码 */
export const PERM_EMPLOYEE_EMPLOYEE_SEND_CREDENTIALS = 'employee:employee:send-credentials' as const;


// ==================== EQUIPMENT ====================

/** EQUIPMENT 权限 */
/** 查看设备台账 */
export const PERM_EQUIPMENT_EQUIPMENT_VIEW = 'equipment:equipment:view' as const;

/** 设备管理 - 导出 */
export const PERM_EQUIPMENT_EQUIPMENT_EXPORT = 'equipment:equipment:export' as const;

/** 新增设备 */
export const PERM_EQUIPMENT_EQUIPMENT_CREATE = 'equipment:equipment:create' as const;

/** 修改设备信息 */
export const PERM_EQUIPMENT_EQUIPMENT_UPDATE = 'equipment:equipment:update' as const;

/** 删除设备 */
export const PERM_EQUIPMENT_EQUIPMENT_DELETE = 'equipment:equipment:delete' as const;

/** 绑定工单 */
export const PERM_EQUIPMENT_EQUIPMENT_BIND = 'equipment:equipment:bind' as const;

/** 上下机操作 */
export const PERM_EQUIPMENT_EQUIPMENT_OPERATE = 'equipment:equipment:operate' as const;

/** 强制下机 */
export const PERM_EQUIPMENT_EQUIPMENT_FORCE_UNBIND = 'equipment:equipment:force-unbind' as const;

/** 设备管理 - 工序配置 */
export const PERM_EQUIPMENT_EQUIPMENT_OPERATION_CONFIG = 'equipment:equipment:operation-config' as const;

/** INSPECTION 权限 */
/** 设备点检 - 查看 */
export const PERM_EQUIPMENT_INSPECTION_VIEW = 'equipment:inspection:view' as const;

/** 提交点检记录 */
export const PERM_EQUIPMENT_INSPECTION_CREATE = 'equipment:inspection:create' as const;

/** INSPECTION-TEMPLATE 权限 */
/** 点检模板 - 查看 */
export const PERM_EQUIPMENT_INSPECTION_TEMPLATE_VIEW = 'equipment:inspection-template:view' as const;

/** 点检模板 - 创建 */
export const PERM_EQUIPMENT_INSPECTION_TEMPLATE_CREATE = 'equipment:inspection-template:create' as const;

/** 点检模板 - 更新 */
export const PERM_EQUIPMENT_INSPECTION_TEMPLATE_UPDATE = 'equipment:inspection-template:update' as const;

/** 点检模板 - 删除 */
export const PERM_EQUIPMENT_INSPECTION_TEMPLATE_DELETE = 'equipment:inspection-template:delete' as const;

/** MAINTENANCE 权限 */
/** 设备保养 - 查看 */
export const PERM_EQUIPMENT_MAINTENANCE_VIEW = 'equipment:maintenance:view' as const;

/** 维护保养管理 */
export const PERM_EQUIPMENT_MAINTENANCE_MANAGE = 'equipment:maintenance:manage' as const;

/** REPAIR 权限 */
/** 设备维修 - 查看 */
export const PERM_EQUIPMENT_REPAIR_VIEW = 'equipment:repair:view' as const;

/** 报修 */
export const PERM_EQUIPMENT_REPAIR_CREATE = 'equipment:repair:create' as const;

/** 维修处理 */
export const PERM_EQUIPMENT_REPAIR_UPDATE = 'equipment:repair:update' as const;

/** 设备维修 - 删除 */
export const PERM_EQUIPMENT_REPAIR_DELETE = 'equipment:repair:delete' as const;

/** 设备维修 - 派单 */
export const PERM_EQUIPMENT_REPAIR_ASSIGN = 'equipment:repair:assign' as const;

/** 执行维修 */
export const PERM_EQUIPMENT_REPAIR_EXECUTE = 'equipment:repair:execute' as const;

/** 设备维修 - 取消 */
export const PERM_EQUIPMENT_REPAIR_CANCEL = 'equipment:repair:cancel' as const;


// ==================== FILE ====================

/** FILE 权限 */
/** 文件 - 业务拍照上传 */
export const PERM_FILE_FILE_BUSINESS_UPLOAD = 'file:file:business-upload' as const;

/** FILE 权限 */
/** 文件 - 查看 */
export const PERM_FILE_FILE_VIEW = 'file:file:view' as const;

/** 文件 - 上传 */
export const PERM_FILE_FILE_UPLOAD = 'file:file:upload' as const;

/** 文件 - 下载 */
export const PERM_FILE_FILE_DOWNLOAD = 'file:file:download' as const;

/** 文件 - 更新 */
export const PERM_FILE_FILE_UPDATE = 'file:file:update' as const;

/** 文件 - 删除 */
export const PERM_FILE_FILE_DELETE = 'file:file:delete' as const;

/** LOG 权限 */
/** 日志 - 查看 */
export const PERM_FILE_LOG_VIEW = 'file:log:view' as const;

/** VERSION 权限 */
/** 版本 - 查看 */
export const PERM_FILE_VERSION_VIEW = 'file:version:view' as const;

/** 版本 - 下载 */
export const PERM_FILE_VERSION_DOWNLOAD = 'file:version:download' as const;

/** 版本 - 回滚 */
export const PERM_FILE_VERSION_ROLLBACK = 'file:version:rollback' as const;

/** FOLDER 权限 */
/** 文件夹 - 查看 */
export const PERM_FILE_FOLDER_VIEW = 'file:folder:view' as const;

/** 文件夹 - 创建 */
export const PERM_FILE_FOLDER_CREATE = 'file:folder:create' as const;

/** 文件夹 - 更新 */
export const PERM_FILE_FOLDER_UPDATE = 'file:folder:update' as const;

/** 文件夹 - 删除 */
export const PERM_FILE_FOLDER_DELETE = 'file:folder:delete' as const;

/** FOLDER 权限 */
/** 文件夹 - 权限 */
export const PERM_FILE_FOLDER_PERMISSION = 'file:folder:permission' as const;

/** STORAGE 权限 */
/** 存储 - 查看 */
export const PERM_FILE_STORAGE_VIEW = 'file:storage:view' as const;


// ==================== INTEGRATION ====================

/** MAPPING-RULE 权限 */
/** 映射规则 - 查看 */
export const PERM_INTEGRATION_MAPPING_RULE_VIEW = 'integration:mapping-rule:view' as const;

/** 映射规则 - 查看 - 预览转换 */
export const PERM_INTEGRATION_MAPPING_RULE_PREVIEW = 'integration:mapping-rule:preview' as const;

/** 映射规则 - 创建 */
export const PERM_INTEGRATION_MAPPING_RULE_CREATE = 'integration:mapping-rule:create' as const;

/** 映射规则 - 更新 */
export const PERM_INTEGRATION_MAPPING_RULE_UPDATE = 'integration:mapping-rule:update' as const;

/** 映射规则 - 删除 */
export const PERM_INTEGRATION_MAPPING_RULE_DELETE = 'integration:mapping-rule:delete' as const;

/** OBJECT-PROFILE 权限 */
/** 对象配置 - 查看 */
export const PERM_INTEGRATION_OBJECT_PROFILE_VIEW = 'integration:object-profile:view' as const;

/** 对象配置 - 创建 */
export const PERM_INTEGRATION_OBJECT_PROFILE_CREATE = 'integration:object-profile:create' as const;

/** 对象配置 - 更新 */
export const PERM_INTEGRATION_OBJECT_PROFILE_UPDATE = 'integration:object-profile:update' as const;

/** 对象配置 - 删除 */
export const PERM_INTEGRATION_OBJECT_PROFILE_DELETE = 'integration:object-profile:delete' as const;

/** SYNC-JOB 权限 */
/** 同步任务 - 查看 */
export const PERM_INTEGRATION_SYNC_JOB_VIEW = 'integration:sync-job:view' as const;

/** 同步任务 - 创建 */
export const PERM_INTEGRATION_SYNC_JOB_CREATE = 'integration:sync-job:create' as const;

/** 同步任务 - 管理 */
export const PERM_INTEGRATION_SYNC_JOB_MANAGE = 'integration:sync-job:manage' as const;


// ==================== INVENTORY ====================

/** INVENTORY 权限 */
/** 查看库存 */
export const PERM_INVENTORY_INVENTORY_VIEW = 'inventory:inventory:view' as const;

/** 库存管理 - 创建 */
export const PERM_INVENTORY_INVENTORY_CREATE = 'inventory:inventory:create' as const;

/** 库存管理 - 更新 */
export const PERM_INVENTORY_INVENTORY_UPDATE = 'inventory:inventory:update' as const;

/** 库存管理 - 删除 */
export const PERM_INVENTORY_INVENTORY_DELETE = 'inventory:inventory:delete' as const;

/** 库存管理 - 出库 */
export const PERM_INVENTORY_INVENTORY_OUTBOUND = 'inventory:inventory:outbound' as const;

/** 库存管理 - 锁定 */
export const PERM_INVENTORY_INVENTORY_LOCK = 'inventory:inventory:lock' as const;

/** 库存管理 - 解锁 */
export const PERM_INVENTORY_INVENTORY_UNLOCK = 'inventory:inventory:unlock' as const;

/** 库存管理 - 转移 */
export const PERM_INVENTORY_INVENTORY_TRANSFER = 'inventory:inventory:transfer' as const;

/** 库存管理 - 导入 */
export const PERM_INVENTORY_INVENTORY_IMPORT = 'inventory:inventory:import' as const;

/** 导出库存 */
export const PERM_INVENTORY_INVENTORY_EXPORT = 'inventory:inventory:export' as const;

/** 库存管理 - 打印批次一联单 */
export const PERM_INVENTORY_BATCH_PRINT = 'inventory:batch:print' as const;

/** 库存管理 - 简化入库（非批次管理物料） */
export const PERM_INVENTORY_INVENTORY_SIMPLE_INBOUND = 'inventory:inventory:simple-inbound' as const;

/** 库存管理 - 简化出库（非批次管理物料） */
export const PERM_INVENTORY_INVENTORY_SIMPLE_OUTBOUND = 'inventory:inventory:simple-outbound' as const;

/** 库存调整（修正数量） */
export const PERM_INVENTORY_INVENTORY_ADJUST = 'inventory:inventory:adjust' as const;

/** 冻结/解冻库存 */
export const PERM_INVENTORY_INVENTORY_FREEZE = 'inventory:inventory:freeze' as const;

/** 强制删除库存（含事务记录） */
export const PERM_INVENTORY_INVENTORY_DELETE_FORCE = 'inventory:inventory:delete-force' as const;

/** INIT 权限 */
/** 库存初始化 - 查看 */
export const PERM_INVENTORY_INIT_VIEW = 'inventory:init:view' as const;

/** 库存初始化 - 创建 */
export const PERM_INVENTORY_INIT_CREATE = 'inventory:init:create' as const;

/** 库存初始化 - 更新 */
export const PERM_INVENTORY_INIT_UPDATE = 'inventory:init:update' as const;

/** 库存初始化 - 删除 */
export const PERM_INVENTORY_INIT_DELETE = 'inventory:init:delete' as const;

/** 库存初始化 - 提交 */
export const PERM_INVENTORY_INIT_SUBMIT = 'inventory:init:submit' as const;

/** MATERIAL-ASSURANCE 权限 */
/** 物料保障工作台 - 查看 */
export const PERM_INVENTORY_MATERIAL_ASSURANCE_VIEW = 'inventory:material-assurance:view' as const;

/** 物料保障工作台 - 管理 */
export const PERM_INVENTORY_MATERIAL_ASSURANCE_MANAGE = 'inventory:material-assurance:manage' as const;

/** MATERIAL-BORROW 权限 */
/** 查看借用记录 */
export const PERM_INVENTORY_MATERIAL_BORROW_VIEW = 'inventory:material-borrow:view' as const;

/** 物料借用 - 我的借用 */
export const PERM_INVENTORY_MATERIAL_BORROW_MY = 'inventory:material-borrow:my' as const;

/** 创建借用申请 */
export const PERM_INVENTORY_MATERIAL_BORROW_CREATE = 'inventory:material-borrow:create' as const;

/** 归还物料 */
export const PERM_INVENTORY_MATERIAL_BORROW_RETURN = 'inventory:material-borrow:return' as const;

/** 确认借用出库（仓管） */
export const PERM_INVENTORY_MATERIAL_BORROW_CONFIRM = 'inventory:material-borrow:confirm' as const;

/** 确认归还入库（仓管） */
export const PERM_INVENTORY_MATERIAL_BORROW_CONFIRM_RETURN = 'inventory:material-borrow:confirm-return' as const;

/** PICKING-STATISTICS 权限 */
/** 领料统计 - 查看 */
export const PERM_INVENTORY_PICKING_STATISTICS_VIEW = 'inventory:picking-statistics:view' as const;

/** STOCKTAKING 权限 */
/** 盘点管理 - 查看 */
export const PERM_INVENTORY_STOCKTAKING_VIEW = 'inventory:stocktaking:view' as const;

/** 盘点管理 - 创建盘点单 */
export const PERM_INVENTORY_STOCKTAKING_CREATE = 'inventory:stocktaking:create' as const;

/** 盘点管理 - 执行盘点 */
export const PERM_INVENTORY_STOCKTAKING_EXECUTE = 'inventory:stocktaking:execute' as const;

/** 盘点管理 - 完成/取消盘点单 */
export const PERM_INVENTORY_STOCKTAKING_MANAGE = 'inventory:stocktaking:manage' as const;

/** 库存预警 - 查看 */
export const PERM_INVENTORY_WARNING_VIEW = 'inventory:warning:view' as const;

/** TRANSACTION 权限 */
/** 查看出入库记录 */
export const PERM_INVENTORY_TRANSACTION_VIEW = 'inventory:transaction:view' as const;

/** 出入库事务 - 导出 */
export const PERM_INVENTORY_TRANSACTION_EXPORT = 'inventory:transaction:export' as const;

/** 审批入库申请 */
export const PERM_INVENTORY_TRANSACTION_APPROVE = 'inventory:transaction:approve' as const;

/** 修改待审核入库数量 */
export const PERM_INVENTORY_TRANSACTION_UPDATE_PENDING = 'inventory:transaction:update-pending' as const;


// ==================== IOT ====================

/** GATEWAY 权限 */
/** 网关 - 查看 */
export const PERM_IOT_GATEWAY_VIEW = 'iot:gateway:view' as const;

/** 网关 - 控制 */
export const PERM_IOT_GATEWAY_CONTROL = 'iot:gateway:control' as const;

/** 报警 - 查看 */
export const PERM_IOT_ALARM_VIEW = 'iot:alarm:view' as const;

/** 报警 - 处理 */
export const PERM_IOT_ALARM_HANDLE = 'iot:alarm:handle' as const;

/** 统计分析 - 查看 */
export const PERM_IOT_STATISTICS_VIEW = 'iot:statistics:view' as const;

/** 网关发现设备 - 查看 */
export const PERM_IOT_DISCOVERED_DEVICE_VIEW = 'iot:discovered-device:view' as const;

/** 网关发现设备 - 绑定 */
export const PERM_IOT_DISCOVERED_DEVICE_BIND = 'iot:discovered-device:bind' as const;

/** 网关发现设备 - 忽略 */
export const PERM_IOT_DISCOVERED_DEVICE_IGNORE = 'iot:discovered-device:ignore' as const;

/** 物联网(IoT) - 跨厂区查看 */
export const PERM_IOT_VIEW_ALL = 'iot:view:all' as const;

/** VENDOR 权限 */
/** 设备厂商 - 查看 */
export const PERM_IOT_VENDOR_VIEW = 'iot:vendor:view' as const;

/** 设备厂商 - 创建 */
export const PERM_IOT_VENDOR_CREATE = 'iot:vendor:create' as const;

/** 设备厂商 - 更新 */
export const PERM_IOT_VENDOR_UPDATE = 'iot:vendor:update' as const;

/** 设备厂商 - 删除 */
export const PERM_IOT_VENDOR_DELETE = 'iot:vendor:delete' as const;


// ==================== LOGISTICS ====================

/** ORDER 权限 */
/** 销售订单 - 查看 */
export const PERM_LOGISTICS_ORDER_VIEW = 'logistics:order:view' as const;

/** 销售订单 - 创建 */
export const PERM_LOGISTICS_ORDER_CREATE = 'logistics:order:create' as const;

/** 销售订单 - 更新 */
export const PERM_LOGISTICS_ORDER_UPDATE = 'logistics:order:update' as const;

/** 销售订单 - 删除 */
export const PERM_LOGISTICS_ORDER_DELETE = 'logistics:order:delete' as const;

/** 销售订单 - 审核 */
export const PERM_LOGISTICS_ORDER_REVIEW = 'logistics:order:review' as const;

/** PROVIDER 权限 */
/** Provider - 查看 */
export const PERM_LOGISTICS_PROVIDER_VIEW = 'logistics:provider:view' as const;

/** Provider - 创建 */
export const PERM_LOGISTICS_PROVIDER_CREATE = 'logistics:provider:create' as const;

/** Provider - 更新 */
export const PERM_LOGISTICS_PROVIDER_UPDATE = 'logistics:provider:update' as const;

/** Provider - 删除 */
export const PERM_LOGISTICS_PROVIDER_DELETE = 'logistics:provider:delete' as const;

/** SETTLEMENT 权限 */
/** Settlement - 查看 */
export const PERM_LOGISTICS_SETTLEMENT_VIEW = 'logistics:settlement:view' as const;

/** Settlement - 创建 */
export const PERM_LOGISTICS_SETTLEMENT_CREATE = 'logistics:settlement:create' as const;

/** Settlement - 更新 */
export const PERM_LOGISTICS_SETTLEMENT_UPDATE = 'logistics:settlement:update' as const;

/** Settlement - 删除 */
export const PERM_LOGISTICS_SETTLEMENT_DELETE = 'logistics:settlement:delete' as const;

/** Settlement - 导入 */
export const PERM_LOGISTICS_SETTLEMENT_IMPORT = 'logistics:settlement:import' as const;

/** Settlement - 确认 */
export const PERM_LOGISTICS_SETTLEMENT_CONFIRM = 'logistics:settlement:confirm' as const;

/** Settlement - 赔付 */
export const PERM_LOGISTICS_SETTLEMENT_PAY = 'logistics:settlement:pay' as const;


// ==================== MANAGEMENT ====================

/** REPORTS 权限 */
/** Reports - 查看 */
export const PERM_MANAGEMENT_REPORTS_VIEW = 'management:reports:view' as const;


// ==================== MATERIAL ====================

/** MATERIAL 权限 */
/** 物料管理 - 查看 */
export const PERM_MATERIAL_MATERIAL_VIEW = 'material:material:view' as const;

/** 新增物料 */
export const PERM_MATERIAL_MATERIAL_CREATE = 'material:material:create' as const;

/** 修改物料 */
export const PERM_MATERIAL_MATERIAL_UPDATE = 'material:material:update' as const;

/** 删除物料 */
export const PERM_MATERIAL_MATERIAL_DELETE = 'material:material:delete' as const;

/** 导入物料 */
export const PERM_MATERIAL_MATERIAL_IMPORT = 'material:material:import' as const;

/** 导出物料 */
export const PERM_MATERIAL_MATERIAL_EXPORT = 'material:material:export' as const;

/** 物料管理 - 单位换算 */
export const PERM_MATERIAL_MATERIAL_CONVERT = 'material:material:convert' as const;

/** 物料管理 - 转为批次管理 */
export const PERM_MATERIAL_MATERIAL_BATCH_CONVERT = 'material:material:batch-convert' as const;


// ==================== NOTIFICATION ====================

/** ADMIN 权限 */
/** 消息管理 - 查看(设置、模板、事件日志、事件统计) */
export const PERM_NOTIFICATION_ADMIN_VIEW = 'notification:admin:view' as const;

/** 消息管理 - 监控(Dashboard、发送记录、失败记录) */
export const PERM_NOTIFICATION_ADMIN_MONITOR = 'notification:admin:monitor' as const;

/** 消息管理 - 重试失败消息 */
export const PERM_NOTIFICATION_ADMIN_RETRY = 'notification:admin:retry' as const;

/** 消息管理 - 创建 */
export const PERM_NOTIFICATION_ADMIN_CREATE = 'notification:admin:create' as const;

/** 消息管理 - 发送 */
export const PERM_NOTIFICATION_ADMIN_SEND = 'notification:admin:send' as const;

/** 消息管理 - 广播 */
export const PERM_NOTIFICATION_ADMIN_BROADCAST = 'notification:admin:broadcast' as const;

/** 消息管理 - 更新(设置、模板) */
export const PERM_NOTIFICATION_ADMIN_UPDATE = 'notification:admin:update' as const;

/** 消息管理 - 删除(模板) */
export const PERM_NOTIFICATION_ADMIN_DELETE = 'notification:admin:delete' as const;

/** 消息管理 - 同步缓存 */
export const PERM_NOTIFICATION_ADMIN_SYNC = 'notification:admin:sync' as const;

/** USER 权限 */
/** 用户消息 - 查看 */
export const PERM_NOTIFICATION_USER_VIEW = 'notification:user:view' as const;

/** 用户消息 - 更新 */
export const PERM_NOTIFICATION_USER_UPDATE = 'notification:user:update' as const;

/** 用户消息 - 删除 */
export const PERM_NOTIFICATION_USER_DELETE = 'notification:user:delete' as const;

/** SYSTEM-RULE 权限 */
/** 系统通知规则 - 查看 */
export const PERM_NOTIFICATION_SYSTEM_RULE_VIEW = 'notification:system-rule:view' as const;

/** 系统通知规则 - 更新 */
export const PERM_NOTIFICATION_SYSTEM_RULE_UPDATE = 'notification:system-rule:update' as const;

/** 系统通知规则 - 删除 */
export const PERM_NOTIFICATION_SYSTEM_RULE_DELETE = 'notification:system-rule:delete' as const;


// ==================== OEE ====================

/** CYCLE-TIME 权限 */
/** 查看周期时间配置 */
export const PERM_OEE_CYCLE_TIME_VIEW = 'oee:cycle-time:view' as const;

/** 创建周期时间配置 */
export const PERM_OEE_CYCLE_TIME_CREATE = 'oee:cycle-time:create' as const;

/** 更新周期时间配置 */
export const PERM_OEE_CYCLE_TIME_UPDATE = 'oee:cycle-time:update' as const;

/** 删除周期时间配置 */
export const PERM_OEE_CYCLE_TIME_DELETE = 'oee:cycle-time:delete' as const;

/** DASHBOARD 权限 */
/** 查看OEE看板 */
export const PERM_OEE_DASHBOARD_VIEW = 'oee:dashboard:view' as const;

/** 手动计算OEE */
export const PERM_OEE_DASHBOARD_CALCULATE = 'oee:dashboard:calculate' as const;

/** 同步安灯数据到OEE */
export const PERM_OEE_DASHBOARD_SYNC_ANDON = 'oee:dashboard:sync-andon' as const;

/** DOWNTIME-REASON 权限 */
/** 查看停机原因 */
export const PERM_OEE_DOWNTIME_REASON_VIEW = 'oee:downtime-reason:view' as const;

/** 创建停机原因 */
export const PERM_OEE_DOWNTIME_REASON_CREATE = 'oee:downtime-reason:create' as const;

/** 更新停机原因 */
export const PERM_OEE_DOWNTIME_REASON_UPDATE = 'oee:downtime-reason:update' as const;

/** 删除停机原因 */
export const PERM_OEE_DOWNTIME_REASON_DELETE = 'oee:downtime-reason:delete' as const;

/** DOWNTIME-RECORD 权限 */
/** 查看停机记录 */
export const PERM_OEE_DOWNTIME_RECORD_VIEW = 'oee:downtime-record:view' as const;

/** 创建停机记录 */
export const PERM_OEE_DOWNTIME_RECORD_CREATE = 'oee:downtime-record:create' as const;

/** 更新停机记录 */
export const PERM_OEE_DOWNTIME_RECORD_UPDATE = 'oee:downtime-record:update' as const;

/** 结束停机 */
export const PERM_OEE_DOWNTIME_RECORD_END = 'oee:downtime-record:end' as const;

/** 核实停机记录 */
export const PERM_OEE_DOWNTIME_RECORD_VERIFY = 'oee:downtime-record:verify' as const;

/** PLANNED-TIME 权限 */
/** 查看计划时间配置 */
export const PERM_OEE_PLANNED_TIME_VIEW = 'oee:planned-time:view' as const;

/** 创建计划时间配置 */
export const PERM_OEE_PLANNED_TIME_CREATE = 'oee:planned-time:create' as const;

/** 更新计划时间配置 */
export const PERM_OEE_PLANNED_TIME_UPDATE = 'oee:planned-time:update' as const;

/** 删除计划时间配置 */
export const PERM_OEE_PLANNED_TIME_DELETE = 'oee:planned-time:delete' as const;


// ==================== OPERATION ====================

/** OPERATION 权限 */
/** 工序管理 - 查看 */
export const PERM_OPERATION_OPERATION_VIEW = 'operation:operation:view' as const;

/** 工序管理 - 创建 */
export const PERM_OPERATION_OPERATION_CREATE = 'operation:operation:create' as const;

/** 工序管理 - 更新 */
export const PERM_OPERATION_OPERATION_UPDATE = 'operation:operation:update' as const;

/** 工序管理 - 删除 */
export const PERM_OPERATION_OPERATION_DELETE = 'operation:operation:delete' as const;

/** 工序管理 - 导入 */
export const PERM_OPERATION_OPERATION_IMPORT = 'operation:operation:import' as const;

/** 工序管理 - 导出 */
export const PERM_OPERATION_OPERATION_EXPORT = 'operation:operation:export' as const;


// ==================== ORGANIZATION ====================

/** FACTORY 权限 */
/** 工厂管理 - 查看 */
export const PERM_ORGANIZATION_FACTORY_VIEW = 'organization:factory:view' as const;

/** 工厂管理 - 创建 */
export const PERM_ORGANIZATION_FACTORY_CREATE = 'organization:factory:create' as const;

/** 工厂管理 - 更新 */
export const PERM_ORGANIZATION_FACTORY_UPDATE = 'organization:factory:update' as const;

/** 工厂管理 - 删除 */
export const PERM_ORGANIZATION_FACTORY_DELETE = 'organization:factory:delete' as const;

/** PRODUCTION-LINE 权限 */
/** 生产线管理 - 查看 */
export const PERM_ORGANIZATION_PRODUCTION_LINE_VIEW = 'organization:production-line:view' as const;

/** 生产线管理 - 创建 */
export const PERM_ORGANIZATION_PRODUCTION_LINE_CREATE = 'organization:production-line:create' as const;

/** 生产线管理 - 更新 */
export const PERM_ORGANIZATION_PRODUCTION_LINE_UPDATE = 'organization:production-line:update' as const;

/** 生产线管理 - 删除 */
export const PERM_ORGANIZATION_PRODUCTION_LINE_DELETE = 'organization:production-line:delete' as const;

/** 生产线管理 - 导入 */
export const PERM_ORGANIZATION_PRODUCTION_LINE_IMPORT = 'organization:production-line:import' as const;

/** TEAM 权限 */
/** 班组管理 - 查看 */
export const PERM_ORGANIZATION_TEAM_VIEW = 'organization:team:view' as const;

/** 班组管理 - 创建 */
export const PERM_ORGANIZATION_TEAM_CREATE = 'organization:team:create' as const;

/** 班组管理 - 更新 */
export const PERM_ORGANIZATION_TEAM_UPDATE = 'organization:team:update' as const;

/** 班组管理 - 删除 */
export const PERM_ORGANIZATION_TEAM_DELETE = 'organization:team:delete' as const;

/** WORKSHOP 权限 */
/** 车间管理 - 查看 */
export const PERM_ORGANIZATION_WORKSHOP_VIEW = 'organization:workshop:view' as const;

/** 车间管理 - 创建 */
export const PERM_ORGANIZATION_WORKSHOP_CREATE = 'organization:workshop:create' as const;

/** 车间管理 - 更新 */
export const PERM_ORGANIZATION_WORKSHOP_UPDATE = 'organization:workshop:update' as const;

/** 车间管理 - 删除 */
export const PERM_ORGANIZATION_WORKSHOP_DELETE = 'organization:workshop:delete' as const;

/** 车间管理 - 导入 */
export const PERM_ORGANIZATION_WORKSHOP_IMPORT = 'organization:workshop:import' as const;

/** WORKSTATION 权限 */
/** 工位管理 - 查看 */
export const PERM_ORGANIZATION_WORKSTATION_VIEW = 'organization:workstation:view' as const;

/** 工位管理 - 创建 */
export const PERM_ORGANIZATION_WORKSTATION_CREATE = 'organization:workstation:create' as const;

/** 工位管理 - 更新 */
export const PERM_ORGANIZATION_WORKSTATION_UPDATE = 'organization:workstation:update' as const;

/** 工位管理 - 删除 */
export const PERM_ORGANIZATION_WORKSTATION_DELETE = 'organization:workstation:delete' as const;

/** 工位管理 - 导入 */
export const PERM_ORGANIZATION_WORKSTATION_IMPORT = 'organization:workstation:import' as const;


// ==================== OUTSOURCE ====================

/** DASHBOARD 权限 */
/** 查看委外看板 */
export const PERM_OUTSOURCE_DASHBOARD_VIEW = 'outsource:dashboard:view' as const;

/** ORDER 权限 */
/** 查看委外订单 */
export const PERM_OUTSOURCE_ORDER_VIEW = 'outsource:order:view' as const;

/** 创建委外订单 */
export const PERM_OUTSOURCE_ORDER_CREATE = 'outsource:order:create' as const;

/** 修改委外订单 */
export const PERM_OUTSOURCE_ORDER_UPDATE = 'outsource:order:update' as const;

/** 删除委外订单 */
export const PERM_OUTSOURCE_ORDER_DELETE = 'outsource:order:delete' as const;

/** 提交委外订单 */
export const PERM_OUTSOURCE_ORDER_SUBMIT = 'outsource:order:submit' as const;

/** 审核委外订单 */
export const PERM_OUTSOURCE_ORDER_APPROVE = 'outsource:order:approve' as const;

/** 取消委外订单 */
export const PERM_OUTSOURCE_ORDER_CANCEL = 'outsource:order:cancel' as const;

/** 关闭委外订单 */
export const PERM_OUTSOURCE_ORDER_CLOSE = 'outsource:order:close' as const;

/** 结算委外订单 */
export const PERM_OUTSOURCE_ORDER_SETTLE = 'outsource:order:settle' as const;

/** RECEIVING 权限 */
/** 查看委外收货 */
export const PERM_OUTSOURCE_RECEIVING_VIEW = 'outsource:receiving:view' as const;

/** 创建委外收货 */
export const PERM_OUTSOURCE_RECEIVING_CREATE = 'outsource:receiving:create' as const;

/** 委外收货入库 */
export const PERM_OUTSOURCE_RECEIVING_WAREHOUSE = 'outsource:receiving:warehouse' as const;

/** 登记委外质检 */
export const PERM_OUTSOURCE_RECEIVING_QUALITY = 'outsource:receiving:quality' as const;

/** 处理委外异常品 */
export const PERM_OUTSOURCE_RECEIVING_EXCEPTION = 'outsource:receiving:exception' as const;

/** RETURN 权限 */
/** 查看委外退料 */
export const PERM_OUTSOURCE_RETURN_VIEW = 'outsource:return:view' as const;

/** 创建委外退料 */
export const PERM_OUTSOURCE_RETURN_CREATE = 'outsource:return:create' as const;

/** 委外退料入库 */
export const PERM_OUTSOURCE_RETURN_WAREHOUSE = 'outsource:return:warehouse' as const;

/** SHIPMENT 权限 */
/** 查看委外发料 */
export const PERM_OUTSOURCE_SHIPMENT_VIEW = 'outsource:shipment:view' as const;

/** 创建委外发料 */
export const PERM_OUTSOURCE_SHIPMENT_CREATE = 'outsource:shipment:create' as const;


// ==================== PLANNING ====================

/** KIT 权限 */
/** 齐套 - 检查 */
export const PERM_PLANNING_KIT_CHECK = 'planning:kit:check' as const;

/** MRP 权限 */
/** MRP - 计算 */
export const PERM_PLANNING_MRP_CALCULATE = 'planning:mrp:calculate' as const;

/** MRP - 查看 */
export const PERM_PLANNING_MRP_VIEW = 'planning:mrp:view' as const;

/** ORDER-FULFILLMENT 权限 */
/** 订单履约评估 - 查看 */
export const PERM_PLANNING_ORDER_FULFILLMENT_VIEW = 'planning:order-fulfillment:view' as const;


// ==================== PRICING ====================

/** CONFIG 权限 */
/** 计价配置 - 查看 */
export const PERM_PRICING_CONFIG_VIEW = 'pricing:config:view' as const;

/** 计价配置 - 创建 */
export const PERM_PRICING_CONFIG_CREATE = 'pricing:config:create' as const;

/** 计价配置 - 更新 */
export const PERM_PRICING_CONFIG_UPDATE = 'pricing:config:update' as const;

/** 计价配置 - 删除 */
export const PERM_PRICING_CONFIG_DELETE = 'pricing:config:delete' as const;

/** PRICE 权限 */
/** 产品工价 - 查看 */
export const PERM_PRICING_PRICE_VIEW = 'pricing:price:view' as const;

/** 产品工价 - 导出 */
export const PERM_PRICING_PRICE_EXPORT = 'pricing:price:export' as const;

/** 产品工价 - 创建 */
export const PERM_PRICING_PRICE_CREATE = 'pricing:price:create' as const;

/** 产品工价 - 更新 */
export const PERM_PRICING_PRICE_UPDATE = 'pricing:price:update' as const;

/** 产品工价 - 删除 */
export const PERM_PRICING_PRICE_DELETE = 'pricing:price:delete' as const;

/** 产品工价 - 导入 */
export const PERM_PRICING_PRICE_IMPORT = 'pricing:price:import' as const;

/** WAGE 权限 */
/** 工资记录 - 查看 */
export const PERM_PRICING_WAGE_VIEW = 'pricing:wage:view' as const;

/** 工资记录 - 导出 */
export const PERM_PRICING_WAGE_EXPORT = 'pricing:wage:export' as const;

/** 工资记录 - 同步当前实时单价 */
export const PERM_PRICING_WAGE_SYNC = 'pricing:wage:sync' as const;

/** 工资记录 - 确认 */
export const PERM_PRICING_WAGE_CONFIRM = 'pricing:wage:confirm' as const;

/** 工资记录 - 结算 */
export const PERM_PRICING_WAGE_SETTLE = 'pricing:wage:settle' as const;

/** 工资记录 - 作废 */
export const PERM_PRICING_WAGE_VOID = 'pricing:wage:void' as const;

/** 工资统计 - 查看 */
export const PERM_PRICING_STATISTICS_VIEW = 'pricing:statistics:view' as const;


// ==================== PRINTER ====================

/** LOG 权限 */
/** 打印日志 - 查看 */
export const PERM_PRINTER_LOG_VIEW = 'printer:log:view' as const;

/** 打印日志 - 上报 */
export const PERM_PRINTER_LOG_CREATE = 'printer:log:create' as const;

/** TEMPLATE 权限 */
/** 打印模板 - 查看 */
export const PERM_PRINTER_TEMPLATE_VIEW = 'printer:template:view' as const;

/** 打印模板 - 创建 */
export const PERM_PRINTER_TEMPLATE_CREATE = 'printer:template:create' as const;

/** 打印模板 - 更新 */
export const PERM_PRINTER_TEMPLATE_UPDATE = 'printer:template:update' as const;

/** 打印模板 - 删除 */
export const PERM_PRINTER_TEMPLATE_DELETE = 'printer:template:delete' as const;

/** PRINTER 权限 */
/** 打印机管理 - 查看 */
export const PERM_PRINTER_PRINTER_VIEW = 'printer:printer:view' as const;

/** 打印机管理 - 创建 */
export const PERM_PRINTER_PRINTER_CREATE = 'printer:printer:create' as const;

/** 打印机管理 - 更新 */
export const PERM_PRINTER_PRINTER_UPDATE = 'printer:printer:update' as const;

/** 打印机管理 - 删除 */
export const PERM_PRINTER_PRINTER_DELETE = 'printer:printer:delete' as const;


// ==================== PROCESSROUTE ====================

/** PROCESS-OPERATION 权限 */
/** 工序管理 - 查看 */
export const PERM_PROCESSROUTE_PROCESS_OPERATION_VIEW = 'processroute:process-operation:view' as const;

/** 工序管理 - 创建 */
export const PERM_PROCESSROUTE_PROCESS_OPERATION_CREATE = 'processroute:process-operation:create' as const;

/** 工序管理 - 更新 */
export const PERM_PROCESSROUTE_PROCESS_OPERATION_UPDATE = 'processroute:process-operation:update' as const;

/** 工序管理 - 删除 */
export const PERM_PROCESSROUTE_PROCESS_OPERATION_DELETE = 'processroute:process-operation:delete' as const;

/** 工序管理 - 导入 */
export const PERM_PROCESSROUTE_PROCESS_OPERATION_IMPORT = 'processroute:process-operation:import' as const;

/** PROCESS-ROUTE 权限 */
/** 工艺路线 - 查看 */
export const PERM_PROCESSROUTE_PROCESS_ROUTE_VIEW = 'processroute:process-route:view' as const;

/** 创建工艺路线 */
export const PERM_PROCESSROUTE_PROCESS_ROUTE_CREATE = 'processroute:process-route:create' as const;

/** 修改工艺路线 */
export const PERM_PROCESSROUTE_PROCESS_ROUTE_UPDATE = 'processroute:process-route:update' as const;

/** 删除工艺路线 */
export const PERM_PROCESSROUTE_PROCESS_ROUTE_DELETE = 'processroute:process-route:delete' as const;

/** 工艺路线 - 审批 */
export const PERM_PROCESSROUTE_PROCESS_ROUTE_APPROVE = 'processroute:process-route:approve' as const;

/** 工艺路线 - 冻结 */
export const PERM_PROCESSROUTE_PROCESS_ROUTE_FREEZE = 'processroute:process-route:freeze' as const;

/** 工艺路线 - 作废 */
export const PERM_PROCESSROUTE_PROCESS_ROUTE_OBSOLETE = 'processroute:process-route:obsolete' as const;

/** 工艺路线 - 导入 */
export const PERM_PROCESSROUTE_PROCESS_ROUTE_IMPORT = 'processroute:process-route:import' as const;

/** TEMPLATE 权限 */
/** 工艺路线模板 - 查看 */
export const PERM_PROCESSROUTE_TEMPLATE_VIEW = 'processroute:template:view' as const;

/** 工艺路线模板 - 创建 */
export const PERM_PROCESSROUTE_TEMPLATE_CREATE = 'processroute:template:create' as const;

/** 工艺路线模板 - 更新 */
export const PERM_PROCESSROUTE_TEMPLATE_UPDATE = 'processroute:template:update' as const;

/** 工艺路线模板 - 删除 */
export const PERM_PROCESSROUTE_TEMPLATE_DELETE = 'processroute:template:delete' as const;

/** 工艺路线模板 - 生成工艺路线 */
export const PERM_PROCESSROUTE_TEMPLATE_GENERATE = 'processroute:template:generate' as const;


// ==================== PRODUCTION ====================

/** DAILY-REPORT 权限 */
/** 查看班长日报 */
export const PERM_PRODUCTION_DAILY_REPORT_VIEW = 'production:daily-report:view' as const;

/** 填写班长日报 */
export const PERM_PRODUCTION_DAILY_REPORT_CREATE = 'production:daily-report:create' as const;

/** 修改班长日报 */
export const PERM_PRODUCTION_DAILY_REPORT_UPDATE = 'production:daily-report:update' as const;

/** 删除班长日报 */
export const PERM_PRODUCTION_DAILY_REPORT_DELETE = 'production:daily-report:delete' as const;

/** 查看班长日报统计 */
export const PERM_PRODUCTION_DAILY_REPORT_STATISTICS = 'production:daily-report:statistics' as const;

/** 切换班长日报推送开关 */
export const PERM_PRODUCTION_DAILY_REPORT_NOTIFICATION_SWITCH = 'production:daily-report:notification-switch' as const;

/** 查看所有班长日报（管理员） */
export const PERM_PRODUCTION_DAILY_REPORT_VIEW_ALL = 'production:daily-report:view-all' as const;

/** MATERIAL-CONSUMPTION 权限 */
/** 查看领料记录 */
export const PERM_PRODUCTION_MATERIAL_CONSUMPTION_VIEW = 'production:material-consumption:view' as const;

/** 领用物料 */
export const PERM_PRODUCTION_MATERIAL_CONSUMPTION_CREATE = 'production:material-consumption:create' as const;

/** 撤销领用 */
export const PERM_PRODUCTION_MATERIAL_CONSUMPTION_DELETE = 'production:material-consumption:delete' as const;

/** SCRAP-RATE 权限 */
/** 工序报废率 - 计算 */
export const PERM_PRODUCTION_SCRAP_RATE_CALCULATE = 'production:scrap-rate:calculate' as const;

/** PRODUCT-OPERATION-PROGRESS 权限 */
/** Product-operation-progress - 查看 */
export const PERM_PRODUCTION_PRODUCT_OPERATION_PROGRESS_VIEW = 'production:product-operation-progress:view' as const;

/** BATCH 权限 */
/** 查看批次 */
export const PERM_PRODUCTION_BATCH_VIEW = 'production:batch:view' as const;

/** 批次追溯 */
export const PERM_PRODUCTION_BATCH_TRACE = 'production:batch:trace' as const;

/** 补打批次标签 */
export const PERM_PRODUCTION_BATCH_REPRINT = 'production:batch:reprint' as const;

/** 切换容器 */
export const PERM_PRODUCTION_BATCH_CONTAINER = 'production:batch:container' as const;

/** DASHBOARD 权限 */
/** 生产看板 - 查看 */
export const PERM_PRODUCTION_DASHBOARD_VIEW = 'production:dashboard:view' as const;

/** ORDER 权限 */
/** 销售订单 - 查看 */
export const PERM_PRODUCTION_ORDER_VIEW = 'production:order:view' as const;

/** 创建生产订单 */
export const PERM_PRODUCTION_ORDER_CREATE = 'production:order:create' as const;

/** 修改生产订单 */
export const PERM_PRODUCTION_ORDER_UPDATE = 'production:order:update' as const;

/** 删除生产订单 */
export const PERM_PRODUCTION_ORDER_DELETE = 'production:order:delete' as const;

/** 销售订单 - 接单 */
export const PERM_PRODUCTION_ORDER_ACCEPT = 'production:order:accept' as const;

/** 审批生产订单 */
export const PERM_PRODUCTION_ORDER_APPROVE = 'production:order:approve' as const;

/** 销售订单 - 启动 */
export const PERM_PRODUCTION_ORDER_START = 'production:order:start' as const;

/** 销售订单 - 完成 */
export const PERM_PRODUCTION_ORDER_COMPLETE = 'production:order:complete' as const;

/** 销售订单 - 取消 */
export const PERM_PRODUCTION_ORDER_CANCEL = 'production:order:cancel' as const;

/** 下发生产订单 */
export const PERM_PRODUCTION_ORDER_DISPATCH = 'production:order:dispatch' as const;

/** 产能统计 - 查看 */
export const PERM_PRODUCTION_CAPACITY_VIEW = 'production:capacity:view' as const;

/** 销售订单 - Operation-change */
export const PERM_PRODUCTION_ORDER_OPERATION_CHANGE = 'production:order:operation-change' as const;

/** REWORK-ORDER 权限 */
/** 返工单 - 查看 */
export const PERM_PRODUCTION_REWORK_ORDER_VIEW = 'production:rework-order:view' as const;

/** 创建返工单 */
export const PERM_PRODUCTION_REWORK_ORDER_CREATE = 'production:rework-order:create' as const;

/** 修改返工单 */
export const PERM_PRODUCTION_REWORK_ORDER_UPDATE = 'production:rework-order:update' as const;

/** 删除返工单 */
export const PERM_PRODUCTION_REWORK_ORDER_DELETE = 'production:rework-order:delete' as const;

/** 返工单 - 审批 */
export const PERM_PRODUCTION_REWORK_ORDER_APPROVE = 'production:rework-order:approve' as const;

/** 返工单 - 执行 */
export const PERM_PRODUCTION_REWORK_ORDER_EXECUTE = 'production:rework-order:execute' as const;

/** SCRAP-ORDER 权限 */
/** 报废单 - 查看 */
export const PERM_PRODUCTION_SCRAP_ORDER_VIEW = 'production:scrap-order:view' as const;

/** 创建报废单 */
export const PERM_PRODUCTION_SCRAP_ORDER_CREATE = 'production:scrap-order:create' as const;

/** 修改报废单 */
export const PERM_PRODUCTION_SCRAP_ORDER_UPDATE = 'production:scrap-order:update' as const;

/** 删除报废单 */
export const PERM_PRODUCTION_SCRAP_ORDER_DELETE = 'production:scrap-order:delete' as const;

/** 审批报废 */
export const PERM_PRODUCTION_SCRAP_ORDER_APPROVE = 'production:scrap-order:approve' as const;

/** WIP 权限 */
/** 在制品 - 查看 */
export const PERM_PRODUCTION_WIP_VIEW = 'production:wip:view' as const;

/** WORK-ORDER 权限 */
/** 生产工单 - 查看 */
export const PERM_PRODUCTION_WORK_ORDER_VIEW = 'production:work-order:view' as const;

/** 创建工单 */
export const PERM_PRODUCTION_WORK_ORDER_CREATE = 'production:work-order:create' as const;

/** 修改工单 */
export const PERM_PRODUCTION_WORK_ORDER_UPDATE = 'production:work-order:update' as const;

/** 修改工单备注（独立授权码，仅计划/生产管理及以上与系统管理员） */
export const PERM_PRODUCTION_WORK_ORDER_UPDATE_REMARK = 'production:work-order:update-remark' as const;

/** 删除工单 */
export const PERM_PRODUCTION_WORK_ORDER_DELETE = 'production:work-order:delete' as const;

/** 接收工单 */
export const PERM_PRODUCTION_WORK_ORDER_ACCEPT = 'production:work-order:accept' as const;

/** 生产工单 - 启动 */
export const PERM_PRODUCTION_WORK_ORDER_START = 'production:work-order:start' as const;

/** 暂停工单 */
export const PERM_PRODUCTION_WORK_ORDER_PAUSE = 'production:work-order:pause' as const;

/** 完工报告 */
export const PERM_PRODUCTION_WORK_ORDER_COMPLETE = 'production:work-order:complete' as const;

/** 取消工单 */
export const PERM_PRODUCTION_WORK_ORDER_CANCEL = 'production:work-order:cancel' as const;

/** 生产工单 - 绑定设备 */
export const PERM_PRODUCTION_WORK_ORDER_BIND_EQUIPMENT = 'production:work-order:bind-equipment' as const;

/** 生产工单 - 打印标签 */
export const PERM_PRODUCTION_WORK_ORDER_PRINT_LABEL = 'production:work-order:print-label' as const;

/** 生产工单 - 生成多级工单 */
export const PERM_PRODUCTION_WORK_ORDER_GENERATE_MULTI_LEVEL = 'production:work-order:generate-multi-level' as const;

/** 生产工单 - 树形查询 */
export const PERM_PRODUCTION_WORK_ORDER_TREE = 'production:work-order:tree' as const;

/** 生产工单 - 产出入库 */
export const PERM_PRODUCTION_WORK_ORDER_OUTPUT_INBOUND = 'production:work-order:output-inbound' as const;

/** 工单转移 */
export const PERM_PRODUCTION_WORK_ORDER_TRANSFER = 'production:work-order:transfer' as const;

/** 生产工单 - Operation-change */
export const PERM_PRODUCTION_WORK_ORDER_OPERATION_CHANGE = 'production:work-order:operation-change' as const;

/** WORK-REPORT 权限 */
/** 查看报工记录 */
export const PERM_PRODUCTION_WORK_REPORT_VIEW = 'production:work-report:view' as const;

/** 提交报工 */
export const PERM_PRODUCTION_WORK_REPORT_CREATE = 'production:work-report:create' as const;

/** 撤销报工 */
export const PERM_PRODUCTION_WORK_REPORT_CANCEL = 'production:work-report:cancel' as const;

/** 删除报工 */
export const PERM_PRODUCTION_WORK_REPORT_DELETE = 'production:work-report:delete' as const;

/** 强制撤销报工（管理员） */
export const PERM_PRODUCTION_WORK_REPORT_FORCE_CANCEL = 'production:work-report:force-cancel' as const;

/** 查看所有报工记录（管理员） */
export const PERM_PRODUCTION_WORK_REPORT_VIEW_ALL = 'production:work-report:view-all' as const;


// ==================== PURCHASE ====================

/** DASHBOARD 权限 */
/** 采购 - 看板 - 查看 */
export const PERM_PURCHASE_DASHBOARD_VIEW = 'purchase:dashboard:view' as const;

/** ORDER 权限 */
/** 采购 - 订单 - 查看 */
export const PERM_PURCHASE_ORDER_VIEW = 'purchase:order:view' as const;

/** 采购 - 订单 - 创建 */
export const PERM_PURCHASE_ORDER_CREATE = 'purchase:order:create' as const;

/** 采购 - 订单 - 更新 */
export const PERM_PURCHASE_ORDER_UPDATE = 'purchase:order:update' as const;

/** 采购 - 订单 - 删除 */
export const PERM_PURCHASE_ORDER_DELETE = 'purchase:order:delete' as const;

/** 采购 - 订单 - 审核 */
export const PERM_PURCHASE_ORDER_APPROVE = 'purchase:order:approve' as const;

/** 采购 - 订单 - 确认 */
export const PERM_PURCHASE_ORDER_CONFIRM = 'purchase:order:confirm' as const;

/** 采购 - 订单 - 取消 */
export const PERM_PURCHASE_ORDER_CANCEL = 'purchase:order:cancel' as const;

/** 采购 - 订单 - 关闭 */
export const PERM_PURCHASE_ORDER_CLOSE = 'purchase:order:close' as const;

/** 采购 - 订单 - 收货 */
export const PERM_PURCHASE_ORDER_RECEIVE = 'purchase:order:receive' as const;

/** 采购 - 订单 - 评分 */
export const PERM_PURCHASE_ORDER_RATE = 'purchase:order:rate' as const;

/** 采购 - 订单 - 统计 */
export const PERM_PURCHASE_ORDER_STATISTICS = 'purchase:order:statistics' as const;

/** 采购 - 订单 - 导出 */
export const PERM_PURCHASE_ORDER_EXPORT = 'purchase:order:export' as const;

/** 采购 - 订单 - 导入 */
export const PERM_PURCHASE_ORDER_IMPORT = 'purchase:order:import' as const;

/** RETURN 权限 */
/** 采购 - 退货单 - 查看 */
export const PERM_PURCHASE_RETURN_VIEW = 'purchase:return:view' as const;

/** 采购退货 */
export const PERM_PURCHASE_RETURN_CREATE = 'purchase:return:create' as const;

/** 采购 - 退货单 - 编辑 */
export const PERM_PURCHASE_RETURN_UPDATE = 'purchase:return:update' as const;

/** 采购 - 退货单 - 删除 */
export const PERM_PURCHASE_RETURN_DELETE = 'purchase:return:delete' as const;

/** 采购 - 退货单 - 提交审批 */
export const PERM_PURCHASE_RETURN_SUBMIT = 'purchase:return:submit' as const;

/** 采购 - 退货单 - 审批 */
export const PERM_PURCHASE_RETURN_APPROVE = 'purchase:return:approve' as const;

/** 采购 - 退货单 - 发货 */
export const PERM_PURCHASE_RETURN_SHIP = 'purchase:return:ship' as const;

/** 采购 - 退货单 - 完成 */
export const PERM_PURCHASE_RETURN_COMPLETE = 'purchase:return:complete' as const;

/** 采购 - 退货单 - 取消 */
export const PERM_PURCHASE_RETURN_CANCEL = 'purchase:return:cancel' as const;

/** RECEIVING 权限 */
/** 采购 - 收货记录 - 查看 */
export const PERM_PURCHASE_RECEIVING_VIEW = 'purchase:receiving:view' as const;

/** 上传收货附件 */
export const PERM_PURCHASE_RECEIVING_UPLOAD = 'purchase:receiving:upload' as const;

/** 采购收货 */
export const PERM_PURCHASE_RECEIVING_RECEIVE = 'purchase:receiving:receive' as const;

/** SUPPLIER-CLAIM 权限 */
/** 供应商索赔 - 查看 */
export const PERM_PURCHASE_SUPPLIER_CLAIM_VIEW = 'purchase:supplier-claim:view' as const;

/** 供应商索赔 - 创建 */
export const PERM_PURCHASE_SUPPLIER_CLAIM_CREATE = 'purchase:supplier-claim:create' as const;

/** 供应商索赔 - 更新 */
export const PERM_PURCHASE_SUPPLIER_CLAIM_UPDATE = 'purchase:supplier-claim:update' as const;

/** 供应商索赔 - 删除 */
export const PERM_PURCHASE_SUPPLIER_CLAIM_DELETE = 'purchase:supplier-claim:delete' as const;

/** 供应商索赔 - 确认 */
export const PERM_PURCHASE_SUPPLIER_CLAIM_CONFIRM = 'purchase:supplier-claim:confirm' as const;

/** 供应商索赔 - 赔付 */
export const PERM_PURCHASE_SUPPLIER_CLAIM_PAY = 'purchase:supplier-claim:pay' as const;

/** 供应商索赔 - 关闭 */
export const PERM_PURCHASE_SUPPLIER_CLAIM_CLOSE = 'purchase:supplier-claim:close' as const;

/** 供应商索赔 - 驳回 */
export const PERM_PURCHASE_SUPPLIER_CLAIM_REJECT = 'purchase:supplier-claim:reject' as const;

/** SUPPLIER 权限 */
/** 采购 - 供应商 - 查看 */
export const PERM_PURCHASE_SUPPLIER_VIEW = 'purchase:supplier:view' as const;

/** 采购 - 供应商 - 创建 */
export const PERM_PURCHASE_SUPPLIER_CREATE = 'purchase:supplier:create' as const;

/** 采购 - 供应商 - 更新 */
export const PERM_PURCHASE_SUPPLIER_UPDATE = 'purchase:supplier:update' as const;

/** 采购 - 供应商 - 删除 */
export const PERM_PURCHASE_SUPPLIER_DELETE = 'purchase:supplier:delete' as const;

/** 采购 - 供应商 - 导出 */
export const PERM_PURCHASE_SUPPLIER_EXPORT = 'purchase:supplier:export' as const;

/** 采购 - 供应商 - 导入 */
export const PERM_PURCHASE_SUPPLIER_IMPORT = 'purchase:supplier:import' as const;

/** 采购 - 供应商 - 统计 */
export const PERM_PURCHASE_SUPPLIER_STATISTICS = 'purchase:supplier:statistics' as const;

/** SUPPLIER 权限 */
/** 采购 - 供应商 - 供应物料管理 */
export const PERM_PURCHASE_SUPPLIER_MATERIALS = 'purchase:supplier:materials' as const;

/** SUPPLIER-PERFORMANCE 权限 */
/** 供应商绩效 - 查看 */
export const PERM_PURCHASE_SUPPLIER_PERFORMANCE_VIEW = 'purchase:supplier-performance:view' as const;

/** 供应商绩效 - 计算 */
export const PERM_PURCHASE_SUPPLIER_PERFORMANCE_CALCULATE = 'purchase:supplier-performance:calculate' as const;

/** 供应商绩效 - 更新 */
export const PERM_PURCHASE_SUPPLIER_PERFORMANCE_UPDATE = 'purchase:supplier-performance:update' as const;


// ==================== QUALITY ====================

/** AQL 权限 */
/** AQL标准 - 查看 */
export const PERM_QUALITY_AQL_VIEW = 'quality:aql:view' as const;

/** AQL标准 - 创建 */
export const PERM_QUALITY_AQL_CREATE = 'quality:aql:create' as const;

/** AQL标准 - 更新 */
export const PERM_QUALITY_AQL_UPDATE = 'quality:aql:update' as const;

/** AQL标准 - 删除 */
export const PERM_QUALITY_AQL_DELETE = 'quality:aql:delete' as const;

/** AQL标准 - 导入 */
export const PERM_QUALITY_AQL_IMPORT = 'quality:aql:import' as const;

/** CAPA 权限 */
/** CAPA纠正预防措施 - 查看 */
export const PERM_QUALITY_CAPA_VIEW = 'quality:capa:view' as const;

/** CAPA纠正预防措施 - 创建 */
export const PERM_QUALITY_CAPA_CREATE = 'quality:capa:create' as const;

/** CAPA纠正预防措施 - 更新 */
export const PERM_QUALITY_CAPA_UPDATE = 'quality:capa:update' as const;

/** CAPA纠正预防措施 - 管理 */
export const PERM_QUALITY_CAPA_MANAGE = 'quality:capa:manage' as const;

/** CAPA纠正预防措施 - 删除 */
export const PERM_QUALITY_CAPA_DELETE = 'quality:capa:delete' as const;

/** DEFECT-REASON 权限 */
/** 不良原因库 - 查看 */
export const PERM_QUALITY_DEFECT_REASON_VIEW = 'quality:defect-reason:view' as const;

/** 不良原因库 - 创建 */
export const PERM_QUALITY_DEFECT_REASON_CREATE = 'quality:defect-reason:create' as const;

/** 不良原因库 - 更新 */
export const PERM_QUALITY_DEFECT_REASON_UPDATE = 'quality:defect-reason:update' as const;

/** 不良原因库 - 删除 */
export const PERM_QUALITY_DEFECT_REASON_DELETE = 'quality:defect-reason:delete' as const;

/** EIGHT-D-LPA 权限 */
/** 8D-LPA配置 - 查看 */
export const PERM_QUALITY_EIGHT_D_LPA_VIEW = 'quality:eight-d-lpa:view' as const;

/** 8D-LPA配置 - 更新 */
export const PERM_QUALITY_EIGHT_D_LPA_UPDATE = 'quality:eight-d-lpa:update' as const;

/** 8D-LPA配置 - 触发LPA任务 */
export const PERM_QUALITY_EIGHT_D_LPA_TRIGGER = 'quality:eight-d-lpa:trigger' as const;

/** 8D 权限 */
/** 8D报告 - 查看 */
export const PERM_QUALITY_8D_VIEW = 'quality:8d:view' as const;

/** 8D报告 - 创建 */
export const PERM_QUALITY_8D_CREATE = 'quality:8d:create' as const;

/** 8D报告 - 更新 */
export const PERM_QUALITY_8D_UPDATE = 'quality:8d:update' as const;

/** 8D报告 - 删除 */
export const PERM_QUALITY_8D_DELETE = 'quality:8d:delete' as const;

/** 8D报告 - 管理团队 */
export const PERM_QUALITY_8D_MANAGE_TEAM = 'quality:8d:manage-team' as const;

/** 8D报告 - 关联NCR */
export const PERM_QUALITY_8D_LINK_NCR = 'quality:8d:link-ncr' as const;

/** 8D报告 - 关闭 */
export const PERM_QUALITY_8D_CLOSE = 'quality:8d:close' as const;

/** IQC 权限 */
/** IQC检验 - 查看 */
export const PERM_QUALITY_IQC_VIEW = 'quality:iqc:view' as const;

/** IQC检验 - 执行 */
export const PERM_QUALITY_IQC_EXECUTE = 'quality:iqc:execute' as const;

/** IQC物料管理 - 查看 */
export const PERM_QUALITY_IQC_MATERIAL_VIEW = 'quality:iqc-material:view' as const;

/** IQC物料管理 - 设置免检/需检验 */
export const PERM_QUALITY_IQC_MATERIAL_UPDATE = 'quality:iqc-material:update' as const;

/** IQC控制模式 - 切换模式 */
export const PERM_QUALITY_IQC_CONTROL_MODE_UPDATE = 'quality:iqc-control-mode:update' as const;

/** INSPECTION-ITEM 权限 */
/** 检验项目 - 查看 */
export const PERM_QUALITY_INSPECTION_ITEM_VIEW = 'quality:inspection-item:view' as const;

/** 检验项目 - 创建 */
export const PERM_QUALITY_INSPECTION_ITEM_CREATE = 'quality:inspection-item:create' as const;

/** 检验项目 - 更新 */
export const PERM_QUALITY_INSPECTION_ITEM_UPDATE = 'quality:inspection-item:update' as const;

/** 检验项目 - 删除 */
export const PERM_QUALITY_INSPECTION_ITEM_DELETE = 'quality:inspection-item:delete' as const;

/** 检验项目 - 导入 */
export const PERM_QUALITY_INSPECTION_ITEM_IMPORT = 'quality:inspection-item:import' as const;

/** 检验项目 - 导出 */
export const PERM_QUALITY_INSPECTION_ITEM_EXPORT = 'quality:inspection-item:export' as const;

/** INSPECTION-SUMMARY 权限 */
/** Inspection-summary - 查看 */
export const PERM_QUALITY_INSPECTION_SUMMARY_VIEW = 'quality:inspection-summary:view' as const;

/** Inspection-summary - 刷新 */
export const PERM_QUALITY_INSPECTION_SUMMARY_REFRESH = 'quality:inspection-summary:refresh' as const;

/** TASK 权限 */
/** 检验任务 - 查看 */
export const PERM_QUALITY_TASK_VIEW = 'quality:task:view' as const;

/** 创建检验任务 */
export const PERM_QUALITY_TASK_CREATE = 'quality:task:create' as const;

/** 执行检验 */
export const PERM_QUALITY_TASK_EXECUTE = 'quality:task:execute' as const;

/** TEMPLATE 权限 */
/** 检验模板 - 查看 */
export const PERM_QUALITY_TEMPLATE_VIEW = 'quality:template:view' as const;

/** 检验模板 - 创建 */
export const PERM_QUALITY_TEMPLATE_CREATE = 'quality:template:create' as const;

/** 检验模板 - 导入 */
export const PERM_QUALITY_TEMPLATE_IMPORT = 'quality:template:import' as const;

/** 检验模板 - 更新 */
export const PERM_QUALITY_TEMPLATE_UPDATE = 'quality:template:update' as const;

/** 检验模板 - 删除 */
export const PERM_QUALITY_TEMPLATE_DELETE = 'quality:template:delete' as const;

/** LPA-ROSTER 权限 */
/** LPA花名册 - 查看 */
export const PERM_QUALITY_LPA_ROSTER_VIEW = 'quality:lpa-roster:view' as const;

/** LPA花名册 - 创建 */
export const PERM_QUALITY_LPA_ROSTER_CREATE = 'quality:lpa-roster:create' as const;

/** LPA花名册 - 更新 */
export const PERM_QUALITY_LPA_ROSTER_UPDATE = 'quality:lpa-roster:update' as const;

/** LPA花名册 - 删除 */
export const PERM_QUALITY_LPA_ROSTER_DELETE = 'quality:lpa-roster:delete' as const;

/** LPA-FINDING 权限 */
/** LPA问题项 - 查看 */
export const PERM_QUALITY_LPA_FINDING_VIEW = 'quality:lpa-finding:view' as const;

/** LPA问题项 - 更新 */
export const PERM_QUALITY_LPA_FINDING_UPDATE = 'quality:lpa-finding:update' as const;

/** LPA问题项 - 指派 */
export const PERM_QUALITY_LPA_FINDING_ASSIGN = 'quality:lpa-finding:assign' as const;

/** LPA问题项 - 关闭 */
export const PERM_QUALITY_LPA_FINDING_CLOSE = 'quality:lpa-finding:close' as const;

/** LPA问题项 - 验证 */
export const PERM_QUALITY_LPA_FINDING_VERIFY = 'quality:lpa-finding:verify' as const;

/** LPA问题项 - 一键创建NCR */
export const PERM_QUALITY_LPA_FINDING_CREATE_NCR = 'quality:lpa-finding:create-ncr' as const;

/** LPA问题项 - 作废 */
export const PERM_QUALITY_LPA_FINDING_CANCEL = 'quality:lpa-finding:cancel' as const;

/** LPA-LAYER 权限 */
/** LPA层级配置 - 查看 */
export const PERM_QUALITY_LPA_LAYER_VIEW = 'quality:lpa-layer:view' as const;

/** LPA层级配置 - 创建 */
export const PERM_QUALITY_LPA_LAYER_CREATE = 'quality:lpa-layer:create' as const;

/** LPA层级配置 - 更新 */
export const PERM_QUALITY_LPA_LAYER_UPDATE = 'quality:lpa-layer:update' as const;

/** LPA层级配置 - 删除 */
export const PERM_QUALITY_LPA_LAYER_DELETE = 'quality:lpa-layer:delete' as const;

/** LPA-LIBRARY 权限 */
/** LPA检查项库 - 查看 */
export const PERM_QUALITY_LPA_LIBRARY_VIEW = 'quality:lpa-library:view' as const;

/** LPA检查项库 - 创建 */
export const PERM_QUALITY_LPA_LIBRARY_CREATE = 'quality:lpa-library:create' as const;

/** LPA检查项库 - 更新 */
export const PERM_QUALITY_LPA_LIBRARY_UPDATE = 'quality:lpa-library:update' as const;

/** LPA检查项库 - 删除 */
export const PERM_QUALITY_LPA_LIBRARY_DELETE = 'quality:lpa-library:delete' as const;

/** LPA-SCHEDULE 权限 */
/** LPA计划 - 查看 */
export const PERM_QUALITY_LPA_SCHEDULE_VIEW = 'quality:lpa-schedule:view' as const;

/** LPA计划 - 创建 */
export const PERM_QUALITY_LPA_SCHEDULE_CREATE = 'quality:lpa-schedule:create' as const;

/** LPA计划 - 更新 */
export const PERM_QUALITY_LPA_SCHEDULE_UPDATE = 'quality:lpa-schedule:update' as const;

/** LPA计划 - 删除 */
export const PERM_QUALITY_LPA_SCHEDULE_DELETE = 'quality:lpa-schedule:delete' as const;

/** LPA计划 - 生成任务 */
export const PERM_QUALITY_LPA_SCHEDULE_GENERATE = 'quality:lpa-schedule:generate' as const;

/** LPA-STATISTICS 权限 */
/** LPA统计 - 查看 */
export const PERM_QUALITY_LPA_STATISTICS_VIEW = 'quality:lpa-statistics:view' as const;

/** LPA-TASK 权限 */
/** LPA任务 - 查看 */
export const PERM_QUALITY_LPA_TASK_VIEW = 'quality:lpa-task:view' as const;

/** LPA模块配置 - 管理（复核/交叉抽检运行时开关） */
export const PERM_QUALITY_LPA_CONFIG_MANAGE = 'quality:lpa-config:manage' as const;

/** LPA任务 - 创建 */
export const PERM_QUALITY_LPA_TASK_CREATE = 'quality:lpa-task:create' as const;

/** LPA任务 - 执行 */
export const PERM_QUALITY_LPA_TASK_EXECUTE = 'quality:lpa-task:execute' as const;

/** LPA任务 - 取消 */
export const PERM_QUALITY_LPA_TASK_CANCEL = 'quality:lpa-task:cancel' as const;

/** LPA任务 - 复核 */
export const PERM_QUALITY_LPA_TASK_REVIEW = 'quality:lpa-task:review' as const;

/** LPA任务 - 交叉抽检 */
export const PERM_QUALITY_LPA_TASK_CROSS_CHECK = 'quality:lpa-task:cross-check' as const;

/** LPA-TEMPLATE 权限 */
/** LPA模板 - 查看 */
export const PERM_QUALITY_LPA_TEMPLATE_VIEW = 'quality:lpa-template:view' as const;

/** LPA模板 - 创建 */
export const PERM_QUALITY_LPA_TEMPLATE_CREATE = 'quality:lpa-template:create' as const;

/** LPA模板 - 更新 */
export const PERM_QUALITY_LPA_TEMPLATE_UPDATE = 'quality:lpa-template:update' as const;

/** LPA模板 - 删除 */
export const PERM_QUALITY_LPA_TEMPLATE_DELETE = 'quality:lpa-template:delete' as const;

/** LPA检查项 - 创建 */
export const PERM_QUALITY_LPA_ITEM_CREATE = 'quality:lpa-item:create' as const;

/** LPA检查项 - 更新 */
export const PERM_QUALITY_LPA_ITEM_UPDATE = 'quality:lpa-item:update' as const;

/** LPA检查项 - 删除 */
export const PERM_QUALITY_LPA_ITEM_DELETE = 'quality:lpa-item:delete' as const;

/** MOBILE 权限 */
/** 查看我的待检任务 */
export const PERM_QUALITY_MOBILE_VIEW = 'quality:mobile:view' as const;

/** 执行移动检验 */
export const PERM_QUALITY_MOBILE_EXECUTE = 'quality:mobile:execute' as const;

/** NCR 权限 */
/** NCR管理 - 查看 */
export const PERM_QUALITY_NCR_VIEW = 'quality:ncr:view' as const;

/** 开具NCR单 */
export const PERM_QUALITY_NCR_CREATE = 'quality:ncr:create' as const;

/** 处理NCR单 */
export const PERM_QUALITY_NCR_UPDATE = 'quality:ncr:update' as const;

/** 审批NCR单 */
export const PERM_QUALITY_NCR_APPROVE = 'quality:ncr:approve' as const;

/** NCR管理 - 执行 */
export const PERM_QUALITY_NCR_EXECUTE = 'quality:ncr:execute' as const;

/** NCR管理 - QRQC升级 */
export const PERM_QUALITY_NCR_QRQC = 'quality:ncr:qrqc' as const;

/** QRQC 权限 */
/** Qrqc - 查看 */
export const PERM_QUALITY_QRQC_VIEW = 'quality:qrqc:view' as const;

/** Qrqc - 创建 */
export const PERM_QUALITY_QRQC_CREATE = 'quality:qrqc:create' as const;

/** Qrqc - Analyze */
export const PERM_QUALITY_QRQC_ANALYZE = 'quality:qrqc:analyze' as const;

/** Qrqc - 验证 */
export const PERM_QUALITY_QRQC_VERIFY = 'quality:qrqc:verify' as const;

/** Qrqc - 驳回 */
export const PERM_QUALITY_QRQC_REJECT = 'quality:qrqc:reject' as const;

/** Qrqc - 关闭 */
export const PERM_QUALITY_QRQC_CLOSE = 'quality:qrqc:close' as const;

/** DASHBOARD 权限 */
/** 质量看板 - 查看 */
export const PERM_QUALITY_DASHBOARD_VIEW = 'quality:dashboard:view' as const;

/** QUICK-INSPECTION 权限 */
/** 执行快速检验 */
export const PERM_QUALITY_QUICK_INSPECTION_CREATE = 'quality:quick-inspection:create' as const;

/** 查看快速检验模板 */
export const PERM_QUALITY_QUICK_INSPECTION_VIEW = 'quality:quick-inspection:view' as const;

/** SELF-INSPECTION 权限 */
/** 自检配置 - 查看 */
export const PERM_QUALITY_SELF_INSPECTION_VIEW = 'quality:self-inspection:view' as const;

/** 自检配置 - 创建 */
export const PERM_QUALITY_SELF_INSPECTION_CREATE = 'quality:self-inspection:create' as const;

/** 自检配置 - 更新 */
export const PERM_QUALITY_SELF_INSPECTION_UPDATE = 'quality:self-inspection:update' as const;

/** 自检配置 - 删除 */
export const PERM_QUALITY_SELF_INSPECTION_DELETE = 'quality:self-inspection:delete' as const;


// ==================== SALES ====================

/** CUSTOMER 权限 */
/** 客户管理 - 查看 */
export const PERM_SALES_CUSTOMER_VIEW = 'sales:customer:view' as const;

/** 客户管理 - 创建 */
export const PERM_SALES_CUSTOMER_CREATE = 'sales:customer:create' as const;

/** 客户管理 - 更新 */
export const PERM_SALES_CUSTOMER_UPDATE = 'sales:customer:update' as const;

/** 客户管理 - 删除 */
export const PERM_SALES_CUSTOMER_DELETE = 'sales:customer:delete' as const;

/** CUSTOMER-MATERIAL-SUPPLIER 权限 */
/** 客户物料指定供应商 - 查看 */
export const PERM_SALES_CUSTOMER_MATERIAL_SUPPLIER_VIEW = 'sales:customer-material-supplier:view' as const;

/** 客户物料指定供应商 - 创建 */
export const PERM_SALES_CUSTOMER_MATERIAL_SUPPLIER_CREATE = 'sales:customer-material-supplier:create' as const;

/** 客户物料指定供应商 - 更新 */
export const PERM_SALES_CUSTOMER_MATERIAL_SUPPLIER_UPDATE = 'sales:customer-material-supplier:update' as const;

/** 客户物料指定供应商 - 删除 */
export const PERM_SALES_CUSTOMER_MATERIAL_SUPPLIER_DELETE = 'sales:customer-material-supplier:delete' as const;

/** 客户物料指定供应商 - 检查 */
export const PERM_SALES_CUSTOMER_MATERIAL_SUPPLIER_CHECK = 'sales:customer-material-supplier:check' as const;

/** ORDER-NUMBER 权限 */
/** 订单编号 - 查看 */
export const PERM_SALES_ORDER_NUMBER_VIEW = 'sales:order-number:view' as const;

/** 订单编号 - 生成 */
export const PERM_SALES_ORDER_NUMBER_CREATE = 'sales:order-number:create' as const;

/** 订单编号 - 更新配置 */
export const PERM_SALES_ORDER_NUMBER_UPDATE = 'sales:order-number:update' as const;

/** ORDER 权限 */
/** 销售订单 - 查看 */
export const PERM_SALES_ORDER_VIEW = 'sales:order:view' as const;

/** 销售订单 - 创建 */
export const PERM_SALES_ORDER_CREATE = 'sales:order:create' as const;

/** 销售订单 - 更新 */
export const PERM_SALES_ORDER_UPDATE = 'sales:order:update' as const;

/** 销售订单 - 删除 */
export const PERM_SALES_ORDER_DELETE = 'sales:order:delete' as const;

/** 销售订单 - 审批 */
export const PERM_SALES_ORDER_APPROVE = 'sales:order:approve' as const;

/** 销售订单 - 取消 */
export const PERM_SALES_ORDER_CANCEL = 'sales:order:cancel' as const;

/** SHIPMENT 权限 */
/** 发货单 - 查看 */
export const PERM_SALES_SHIPMENT_VIEW = 'sales:shipment:view' as const;

/** 发货单 - 创建 */
export const PERM_SALES_SHIPMENT_CREATE = 'sales:shipment:create' as const;

/** 发货单 - 确认 */
export const PERM_SALES_SHIPMENT_CONFIRM = 'sales:shipment:confirm' as const;

/** 发货单 - 收货 */
export const PERM_SALES_SHIPMENT_RECEIVE = 'sales:shipment:receive' as const;

/** 发货单 - 取消 */
export const PERM_SALES_SHIPMENT_CANCEL = 'sales:shipment:cancel' as const;


// ==================== SYSTEM ====================

/** AUDIT 权限 */
/** 审计日志 - 查看 */
export const PERM_SYSTEM_AUDIT_VIEW = 'system:audit:view' as const;

/** 审计日志 - 导出 */
export const PERM_SYSTEM_AUDIT_EXPORT = 'system:audit:export' as const;

/** LOGIN-LOG 权限 */
/** 登录日志 - 查看 */
export const PERM_SYSTEM_LOGIN_LOG_VIEW = 'system:login-log:view' as const;

/** 登录日志 - 导出 */
export const PERM_SYSTEM_LOGIN_LOG_EXPORT = 'system:login-log:export' as const;

/** PERMISSION 权限 */
/** 权限管理 - 查看 */
export const PERM_SYSTEM_PERMISSION_VIEW = 'system:permission:view' as const;

/** 创建权限 */
export const PERM_SYSTEM_PERMISSION_CREATE = 'system:permission:create' as const;

/** 权限管理 - 更新 */
export const PERM_SYSTEM_PERMISSION_UPDATE = 'system:permission:update' as const;

/** 权限管理 - 删除 */
export const PERM_SYSTEM_PERMISSION_DELETE = 'system:permission:delete' as const;

/** 权限管理 - 缓存刷新 */
export const PERM_SYSTEM_PERMISSION_CACHE = 'system:permission:cache' as const;

/** ROLE 权限 */
/** 角色管理 - 查看 */
export const PERM_SYSTEM_ROLE_VIEW = 'system:role:view' as const;

/** 创建角色 */
export const PERM_SYSTEM_ROLE_CREATE = 'system:role:create' as const;

/** 修改角色 */
export const PERM_SYSTEM_ROLE_UPDATE = 'system:role:update' as const;

/** 删除角色 */
export const PERM_SYSTEM_ROLE_DELETE = 'system:role:delete' as const;

/** ROLE-WIZARD 权限 */
/** 角色向导 - 查看 */
export const PERM_SYSTEM_ROLE_WIZARD_VIEW = 'system:role-wizard:view' as const;

/** 角色向导 - Cache */
export const PERM_SYSTEM_ROLE_WIZARD_CACHE = 'system:role-wizard:cache' as const;

/** USER 权限 */
/** 用户管理 - 查看 */
export const PERM_SYSTEM_USER_VIEW = 'system:user:view' as const;

/** 创建用户 */
export const PERM_SYSTEM_USER_CREATE = 'system:user:create' as const;

/** 修改用户 */
export const PERM_SYSTEM_USER_UPDATE = 'system:user:update' as const;

/** 删除用户 */
export const PERM_SYSTEM_USER_DELETE = 'system:user:delete' as const;

/** DEPARTMENT 权限 */
/** 部门管理 - 查看 */
export const PERM_SYSTEM_DEPARTMENT_VIEW = 'system:department:view' as const;

/** 部门管理 - 创建 */
export const PERM_SYSTEM_DEPARTMENT_CREATE = 'system:department:create' as const;

/** 部门管理 - 更新 */
export const PERM_SYSTEM_DEPARTMENT_UPDATE = 'system:department:update' as const;

/** 部门管理 - 删除 */
export const PERM_SYSTEM_DEPARTMENT_DELETE = 'system:department:delete' as const;

/** 部门管理 - 企业微信同步 */
export const PERM_SYSTEM_DEPARTMENT_SYNC = 'system:department:sync' as const;

/** FEEDBACK 权限 */
/** 意见反馈 - 查看 */
export const PERM_SYSTEM_FEEDBACK_VIEW = 'system:feedback:view' as const;

/** 意见反馈 - 回复 */
export const PERM_SYSTEM_FEEDBACK_REPLY = 'system:feedback:reply' as const;

/** 意见反馈 - 更新状态 */
export const PERM_SYSTEM_FEEDBACK_UPDATE_STATUS = 'system:feedback:update-status' as const;

/** 意见反馈 - 删除 */
export const PERM_SYSTEM_FEEDBACK_DELETE = 'system:feedback:delete' as const;

/** APP-VERSION 权限 */
/** APP版本 - 检测更新 */
export const PERM_SYSTEM_APP_VERSION_CHECK = 'system:app-version:check' as const;

/** APP版本 - 记录更新日志 */
export const PERM_SYSTEM_APP_VERSION_LOG_UPDATE = 'system:app-version:log-update' as const;

/** CAPABILITY-PROFILE 权限 */
/** 能力档案 - 查看 */
export const PERM_SYSTEM_CAPABILITY_PROFILE_VIEW = 'system:capability-profile:view' as const;

/** 能力档案 - 创建 */
export const PERM_SYSTEM_CAPABILITY_PROFILE_CREATE = 'system:capability-profile:create' as const;

/** 能力档案 - 更新 */
export const PERM_SYSTEM_CAPABILITY_PROFILE_UPDATE = 'system:capability-profile:update' as const;

/** 能力档案 - 删除 */
export const PERM_SYSTEM_CAPABILITY_PROFILE_DELETE = 'system:capability-profile:delete' as const;

/** CUSTOMER-VERSION 权限 */
/** 客户版本 - 查看 */
export const PERM_SYSTEM_CUSTOMER_VERSION_VIEW = 'system:customer-version:view' as const;

/** 客户版本 - 创建 */
export const PERM_SYSTEM_CUSTOMER_VERSION_CREATE = 'system:customer-version:create' as const;

/** 客户版本 - 更新 */
export const PERM_SYSTEM_CUSTOMER_VERSION_UPDATE = 'system:customer-version:update' as const;

/** 客户版本 - 删除 */
export const PERM_SYSTEM_CUSTOMER_VERSION_DELETE = 'system:customer-version:delete' as const;

/** LOGS 权限 */
/** 错误日志 - 查看 */
export const PERM_SYSTEM_LOGS_VIEW = 'system:logs:view' as const;

/** 错误日志 - 删除 */
export const PERM_SYSTEM_LOGS_DELETE = 'system:logs:delete' as const;

/** MENU 权限 */
/** 菜单管理 - 查看 */
export const PERM_SYSTEM_MENU_VIEW = 'system:menu:view' as const;

/** 创建菜单 */
export const PERM_SYSTEM_MENU_CREATE = 'system:menu:create' as const;

/** 修改菜单 */
export const PERM_SYSTEM_MENU_UPDATE = 'system:menu:update' as const;

/** 菜单管理 - 删除 */
export const PERM_SYSTEM_MENU_DELETE = 'system:menu:delete' as const;

/** CONFIG 权限 */
/** 系统配置 - 查看 */
export const PERM_SYSTEM_CONFIG_VIEW = 'system:config:view' as const;

/** 系统配置 - 创建 */
export const PERM_SYSTEM_CONFIG_CREATE = 'system:config:create' as const;

/** 系统配置 - 更新 */
export const PERM_SYSTEM_CONFIG_UPDATE = 'system:config:update' as const;

/** 系统配置 - 删除 */
export const PERM_SYSTEM_CONFIG_DELETE = 'system:config:delete' as const;

/** TV-DEVICE 权限 */
/** TV 设备 - 查看 */
export const PERM_SYSTEM_TV_DEVICE_VIEW = 'system:tv-device:view' as const;

/** TV 设备 - 管理（删除） */
export const PERM_SYSTEM_TV_DEVICE_MANAGE = 'system:tv-device:manage' as const;


// ==================== TOOLING ====================

/** FIXTURE 权限 */
/** 夹具管理 - 查看 */
export const PERM_TOOLING_FIXTURE_VIEW = 'tooling:fixture:view' as const;

/** 夹具管理 - 创建 */
export const PERM_TOOLING_FIXTURE_CREATE = 'tooling:fixture:create' as const;

/** 夹具管理 - 更新 */
export const PERM_TOOLING_FIXTURE_UPDATE = 'tooling:fixture:update' as const;

/** 夹具管理 - 删除 */
export const PERM_TOOLING_FIXTURE_DELETE = 'tooling:fixture:delete' as const;

/** GAUGE 权限 */
/** 检具管理 - 查看 */
export const PERM_TOOLING_GAUGE_VIEW = 'tooling:gauge:view' as const;

/** 检具管理 - 创建 */
export const PERM_TOOLING_GAUGE_CREATE = 'tooling:gauge:create' as const;

/** 检具管理 - 更新 */
export const PERM_TOOLING_GAUGE_UPDATE = 'tooling:gauge:update' as const;

/** 检具管理 - 删除 */
export const PERM_TOOLING_GAUGE_DELETE = 'tooling:gauge:delete' as const;

/** 借用检具 */
export const PERM_TOOLING_GAUGE_BORROW = 'tooling:gauge:borrow' as const;

/** 检具管理 - 校准录入 */
export const PERM_TOOLING_GAUGE_CALIBRATE = 'tooling:gauge:calibrate' as const;

/** 绑定检具 */
export const PERM_TOOLING_GAUGE_MOUNT = 'tooling:gauge:mount' as const;

/** 检具管理 - 蓝牙绑定登记 */
export const PERM_TOOLING_GAUGE_BLUETOOTH_BIND = 'tooling:gauge:bluetooth-bind' as const;

/** 检具管理 - 蓝牙换绑解绑（特殊权限：默认不授予任何角色，仅超级管理员；需由超级管理员在角色权限中定向授予） */
export const PERM_TOOLING_GAUGE_BLUETOOTH_REBIND = 'tooling:gauge:bluetooth-rebind' as const;

/** MOLD 权限 */
/** 模具管理 - 查看 */
export const PERM_TOOLING_MOLD_VIEW = 'tooling:mold:view' as const;

/** 模具管理 - 创建 */
export const PERM_TOOLING_MOLD_CREATE = 'tooling:mold:create' as const;

/** 模具管理 - 更新 */
export const PERM_TOOLING_MOLD_UPDATE = 'tooling:mold:update' as const;

/** 模具管理 - 删除 */
export const PERM_TOOLING_MOLD_DELETE = 'tooling:mold:delete' as const;

/** TOOL 权限 */
/** 刀具管理 - 查看 */
export const PERM_TOOLING_TOOL_VIEW = 'tooling:tool:view' as const;

/** 新增工装 */
export const PERM_TOOLING_TOOL_CREATE = 'tooling:tool:create' as const;

/** 修改工装 */
export const PERM_TOOLING_TOOL_UPDATE = 'tooling:tool:update' as const;

/** 刀具管理 - 删除 */
export const PERM_TOOLING_TOOL_DELETE = 'tooling:tool:delete' as const;

/** 更换工装 */
export const PERM_TOOLING_TOOL_REPLACE = 'tooling:tool:replace' as const;

/** DASHBOARD 权限 */
/** 工装看板 - 查看 */
export const PERM_TOOLING_DASHBOARD_VIEW = 'tooling:dashboard:view' as const;

/** 工装领用 - 查看 */
export const PERM_TOOLING_APPLICATION_VIEW = 'tooling:application:view' as const;

/** 工装领用 - 领用 */
export const PERM_TOOLING_APPLICATION_CREATE = 'tooling:application:create' as const;

/** 工装领用 - 归还 */
export const PERM_TOOLING_APPLICATION_RETURN = 'tooling:application:return' as const;

/** 工装领用 - 撤销 */
export const PERM_TOOLING_APPLICATION_CANCEL = 'tooling:application:cancel' as const;

/** 工装预警 - 查看 */
export const PERM_TOOLING_ALERT_VIEW = 'tooling:alert:view' as const;

/** 工装预警 - 处理 */
export const PERM_TOOLING_ALERT_HANDLE = 'tooling:alert:handle' as const;


// ==================== TRACE ====================

/** TRACE 权限 */
/** 追溯 - 查看 */
export const PERM_TRACE_TRACE_VIEW = 'trace:trace:view' as const;

/** 追溯 - 正向 */
export const PERM_TRACE_TRACE_FORWARD = 'trace:trace:forward' as const;

/** 追溯 - 反向 */
export const PERM_TRACE_TRACE_BACKWARD = 'trace:trace:backward' as const;

/** 追溯 - 完整 */
export const PERM_TRACE_TRACE_FULL = 'trace:trace:full' as const;

/** 追溯 - 生命周期 */
export const PERM_TRACE_TRACE_LIFECYCLE = 'trace:trace:lifecycle' as const;


// ==================== TRAINING ====================

/** MY 权限 */
/** 查看我的培训 */
export const PERM_TRAINING_MY_VIEW = 'training:my:view' as const;

/** 我的培训-查看详情 */
export const PERM_TRAINING_MY_DETAIL = 'training:my:detail' as const;

/** 我的培训-查看记录 */
export const PERM_TRAINING_MY_RECORDS = 'training:my:records' as const;

/** 确认培训完成 */
export const PERM_TRAINING_MY_CONFIRM = 'training:my:confirm' as const;

/** 培训签到 */
export const PERM_TRAINING_MY_SIGN_IN = 'training:my:sign-in' as const;

/** 我的培训-确认完成 */
export const PERM_TRAINING_MY_COMPLETE = 'training:my:complete' as const;

/** PARTICIPANT 权限 */
/** 查看参与者 */
export const PERM_TRAINING_PARTICIPANT_VIEW = 'training:participant:view' as const;

/** 添加参与者 */
export const PERM_TRAINING_PARTICIPANT_ADD = 'training:participant:add' as const;

/** 参与者-批量添加 */
export const PERM_TRAINING_PARTICIPANT_ADD_BATCH = 'training:participant:add-batch' as const;

/** 移除参与者 */
export const PERM_TRAINING_PARTICIPANT_REMOVE = 'training:participant:remove' as const;

/** 标记参与者到场 */
export const PERM_TRAINING_PARTICIPANT_MARK_ATTENDANCE = 'training:participant:mark-attendance' as const;

/** 参与者-批量标记 */
export const PERM_TRAINING_PARTICIPANT_BATCH_MARK = 'training:participant:batch-mark' as const;

/** 参与者-标记补训 */
export const PERM_TRAINING_PARTICIPANT_MARK_MAKEUP = 'training:participant:mark-makeup' as const;

/** STATISTICS 权限 */
/** 查看培训统计 */
export const PERM_TRAINING_STATISTICS_OVERVIEW = 'training:statistics:overview' as const;

/** 统计-按部门 */
export const PERM_TRAINING_STATISTICS_BY_DEPARTMENT = 'training:statistics:by-department' as const;

/** 统计-按类型 */
export const PERM_TRAINING_STATISTICS_BY_TYPE = 'training:statistics:by-type' as const;

/** 统计-按员工 */
export const PERM_TRAINING_STATISTICS_BY_EMPLOYEE = 'training:statistics:by-employee' as const;

/** TASK 权限 */
/** 查看培训任务列表 */
export const PERM_TRAINING_TASK_VIEW = 'training:task:view' as const;

/** 查看培训任务详情 */
export const PERM_TRAINING_TASK_DETAIL = 'training:task:detail' as const;

/** 创建培训任务 */
export const PERM_TRAINING_TASK_CREATE = 'training:task:create' as const;

/** 修改培训任务 */
export const PERM_TRAINING_TASK_UPDATE = 'training:task:update' as const;

/** 删除培训任务 */
export const PERM_TRAINING_TASK_DELETE = 'training:task:delete' as const;

/** 发布培训任务 */
export const PERM_TRAINING_TASK_PUBLISH = 'training:task:publish' as const;

/** 取消培训任务 */
export const PERM_TRAINING_TASK_CANCEL = 'training:task:cancel' as const;

/** 培训任务-开始培训 */
export const PERM_TRAINING_TASK_START = 'training:task:start' as const;

/** 培训任务-签到码管理 */
export const PERM_TRAINING_TASK_SIGN_CODE = 'training:task:sign-code' as const;

/** 培训任务-完成确认 */
export const PERM_TRAINING_TASK_COMPLETE = 'training:task:complete' as const;

/** 培训任务-关闭 */
export const PERM_TRAINING_TASK_CLOSE = 'training:task:close' as const;

/** 补训任务-查看 */
export const PERM_TRAINING_MAKEUP_VIEW = 'training:makeup:view' as const;

/** 补训任务-创建 */
export const PERM_TRAINING_MAKEUP_CREATE = 'training:makeup:create' as const;

/** 补训任务-查看需补训人员 */
export const PERM_TRAINING_MAKEUP_REQUIRED = 'training:makeup:required' as const;

/** TYPE 权限 */
/** 查看培训类型 */
export const PERM_TRAINING_TYPE_VIEW = 'training:type:view' as const;

/** 创建培训类型 */
export const PERM_TRAINING_TYPE_CREATE = 'training:type:create' as const;

/** 修改培训类型 */
export const PERM_TRAINING_TYPE_UPDATE = 'training:type:update' as const;

/** 删除培训类型 */
export const PERM_TRAINING_TYPE_DELETE = 'training:type:delete' as const;

/** 培训类型-启用禁用 */
export const PERM_TRAINING_TYPE_TOGGLE = 'training:type:toggle' as const;


// ==================== WAREHOUSE ====================

/** LOCATION 权限 */
/** 库位管理 - 查看 */
export const PERM_WAREHOUSE_LOCATION_VIEW = 'warehouse:location:view' as const;

/** 新增库位 */
export const PERM_WAREHOUSE_LOCATION_CREATE = 'warehouse:location:create' as const;

/** 修改库位 */
export const PERM_WAREHOUSE_LOCATION_UPDATE = 'warehouse:location:update' as const;

/** 库位管理 - 删除 */
export const PERM_WAREHOUSE_LOCATION_DELETE = 'warehouse:location:delete' as const;

/** 库位管理 - 导入 */
export const PERM_WAREHOUSE_LOCATION_IMPORT = 'warehouse:location:import' as const;

/** WAREHOUSE 权限 */
/** 仓库管理 - 查看 */
export const PERM_WAREHOUSE_WAREHOUSE_VIEW = 'warehouse:warehouse:view' as const;

/** 新增仓库 */
export const PERM_WAREHOUSE_WAREHOUSE_CREATE = 'warehouse:warehouse:create' as const;

/** 修改仓库 */
export const PERM_WAREHOUSE_WAREHOUSE_UPDATE = 'warehouse:warehouse:update' as const;

/** 仓库管理 - 删除 */
export const PERM_WAREHOUSE_WAREHOUSE_DELETE = 'warehouse:warehouse:delete' as const;

/** 仓库管理 - 导入 */
export const PERM_WAREHOUSE_WAREHOUSE_IMPORT = 'warehouse:warehouse:import' as const;


// ==================== WEB-LOGS ====================

/** FUNNEL 权限 */
/** 查看 Web 漏斗分析 */
export const PERM_WEB_LOGS_FUNNEL_VIEW = 'web-logs:funnel:view' as const;

/** 管理 Web 漏斗定义（创建/更新/删除） */
export const PERM_WEB_LOGS_FUNNEL_MANAGE = 'web-logs:funnel:manage' as const;

/** DASHBOARD 权限 */
/** 看板 - 查看 */
export const PERM_WEB_LOGS_DASHBOARD_VIEW = 'web-logs:dashboard:view' as const;

/** 错误日志 - 查看 */
export const PERM_WEB_LOGS_ERROR_LOG_VIEW = 'web-logs:error-log:view' as const;

/** 还原 Web 前端错误压缩堆栈为源码位置 */
export const PERM_WEB_LOGS_SOURCEMAP_RESOLVE = 'web-logs:sourcemap:resolve' as const;

/** 性能日志 - 查看 */
export const PERM_WEB_LOGS_PERFORMANCE_LOG_VIEW = 'web-logs:performance-log:view' as const;

/** 监控告警 - 查看 */
export const PERM_WEB_LOGS_ALERT_VIEW = 'web-logs:alert:view' as const;

/** 监控告警 - 处理 */
export const PERM_WEB_LOGS_ALERT_HANDLE = 'web-logs:alert:handle' as const;

/** 上传 Web 前端 sourcemap（构建发布环节使用） */
export const PERM_WEB_LOGS_SOURCEMAP_UPLOAD = 'web-logs:sourcemap:upload' as const;

/** 行为日志 - 查看 */
export const PERM_WEB_LOGS_BEHAVIOR_LOG_VIEW = 'web-logs:behavior-log:view' as const;


// ==================== WEWORK ====================

/** AUTH 权限 */
/** 企业微信 - 登录认证 */
export const PERM_WEWORK_AUTH_LOGIN = 'wework:auth:login' as const;

/** 企业微信 - 获取配置 */
export const PERM_WEWORK_AUTH_CONFIG = 'wework:auth:config' as const;

/** 企业微信 - 绑定账号 */
export const PERM_WEWORK_AUTH_BIND = 'wework:auth:bind' as const;


// ==================== WORKBENCH ====================

/** DASHBOARD 权限 */
/** 工作台 - 查看仪表板 */
export const PERM_WORKBENCH_DASHBOARD_VIEW = 'workbench:dashboard:view' as const;

/** 帮助中心 - 查看SOP与培训文档 */
export const PERM_DOCS_HELP_VIEW = 'docs:help:view' as const;

/** 个人中心 - 查看个人资料 */
export const PERM_PERSONAL_PROFILE_VIEW = 'personal:profile:view' as const;

/** 个人中心 - 更新个人资料 */
export const PERM_PERSONAL_PROFILE_UPDATE = 'personal:profile:update' as const;

/** 个人中心 - 查看个人设置 */
export const PERM_PERSONAL_SETTINGS_VIEW = 'personal:settings:view' as const;

/** 个人中心 - 更新个人设置 */
export const PERM_PERSONAL_SETTINGS_UPDATE = 'personal:settings:update' as const;

/** 个人中心 - 修改密码 */
export const PERM_PERSONAL_PASSWORD_UPDATE = 'personal:password:update' as const;

/** 消息中心 - 查看消息设置 */
export const PERM_NOTIFICATION_SETTINGS_VIEW = 'notification:settings:view' as const;


/** 所有 API 权限列表 */
export const ALL_API_PERMISSIONS = [
  PERM_SYSTEM_AUDIT_VIEW,
  PERM_SYSTEM_AUDIT_EXPORT,
  PERM_WORKBENCH_DASHBOARD_VIEW,
  PERM_DOCS_HELP_VIEW,
  PERM_PERSONAL_PROFILE_VIEW,
  PERM_PERSONAL_PROFILE_UPDATE,
  PERM_PERSONAL_SETTINGS_VIEW,
  PERM_PERSONAL_SETTINGS_UPDATE,
  PERM_PERSONAL_PASSWORD_UPDATE,
  PERM_NOTIFICATION_SETTINGS_VIEW,
  PERM_SYSTEM_LOGIN_LOG_VIEW,
  PERM_SYSTEM_LOGIN_LOG_EXPORT,
  PERM_SYSTEM_PERMISSION_VIEW,
  PERM_SYSTEM_PERMISSION_CREATE,
  PERM_SYSTEM_PERMISSION_UPDATE,
  PERM_SYSTEM_PERMISSION_DELETE,
  PERM_SYSTEM_PERMISSION_CACHE,
  PERM_SYSTEM_ROLE_VIEW,
  PERM_SYSTEM_ROLE_CREATE,
  PERM_SYSTEM_ROLE_UPDATE,
  PERM_SYSTEM_ROLE_DELETE,
  PERM_SYSTEM_ROLE_WIZARD_VIEW,
  PERM_SYSTEM_ROLE_WIZARD_CACHE,
  PERM_TRAINING_MY_VIEW,
  PERM_TRAINING_MY_DETAIL,
  PERM_TRAINING_MY_RECORDS,
  PERM_TRAINING_MY_CONFIRM,
  PERM_TRAINING_MY_SIGN_IN,
  PERM_TRAINING_MY_COMPLETE,
  PERM_TRAINING_PARTICIPANT_VIEW,
  PERM_TRAINING_PARTICIPANT_ADD,
  PERM_TRAINING_PARTICIPANT_ADD_BATCH,
  PERM_TRAINING_PARTICIPANT_REMOVE,
  PERM_TRAINING_PARTICIPANT_MARK_ATTENDANCE,
  PERM_TRAINING_PARTICIPANT_BATCH_MARK,
  PERM_TRAINING_PARTICIPANT_MARK_MAKEUP,
  PERM_TRAINING_STATISTICS_OVERVIEW,
  PERM_TRAINING_STATISTICS_BY_DEPARTMENT,
  PERM_TRAINING_STATISTICS_BY_TYPE,
  PERM_TRAINING_STATISTICS_BY_EMPLOYEE,
  PERM_TRAINING_TASK_VIEW,
  PERM_TRAINING_TASK_DETAIL,
  PERM_TRAINING_TASK_CREATE,
  PERM_TRAINING_TASK_UPDATE,
  PERM_TRAINING_TASK_DELETE,
  PERM_TRAINING_TASK_PUBLISH,
  PERM_TRAINING_TASK_CANCEL,
  PERM_TRAINING_TASK_START,
  PERM_TRAINING_TASK_SIGN_CODE,
  PERM_TRAINING_TASK_COMPLETE,
  PERM_TRAINING_TASK_CLOSE,
  PERM_TRAINING_MAKEUP_VIEW,
  PERM_TRAINING_MAKEUP_CREATE,
  PERM_TRAINING_MAKEUP_REQUIRED,
  PERM_TRAINING_TYPE_VIEW,
  PERM_TRAINING_TYPE_CREATE,
  PERM_TRAINING_TYPE_UPDATE,
  PERM_TRAINING_TYPE_DELETE,
  PERM_TRAINING_TYPE_TOGGLE,
  PERM_SYSTEM_USER_VIEW,
  PERM_SYSTEM_USER_CREATE,
  PERM_SYSTEM_USER_UPDATE,
  PERM_SYSTEM_USER_DELETE,
  PERM_ANDON_BINDING_VIEW,
  PERM_ANDON_BINDING_CREATE,
  PERM_ANDON_BINDING_UPDATE,
  PERM_ANDON_BINDING_DELETE,
  PERM_ANDON_CALL_CREATE,
  PERM_ANDON_CALL_VIEW,
  PERM_ANDON_CALL_RESPOND,
  PERM_ANDON_CALL_COMPLETE,
  PERM_ANDON_CALL_CANCEL,
  PERM_ANDON_CALL_TYPE_VIEW,
  PERM_ANDON_CALL_TYPE_CREATE,
  PERM_ANDON_CALL_TYPE_UPDATE,
  PERM_ANDON_CALL_TYPE_DELETE,
  PERM_ANDON_NOTIFICATION_CONFIG_VIEW,
  PERM_ANDON_NOTIFICATION_CONFIG_UPDATE,
  PERM_ANDON_DEVICE_VIEW,
  PERM_ANDON_DEVICE_CREATE,
  PERM_ANDON_DEVICE_UPDATE,
  PERM_ANDON_DEVICE_DELETE,
  PERM_ANDON_STATISTICS_VIEW,
  PERM_ANDON_STATISTICS_EXPORT,
  PERM_APP_LOGS_FUNNEL_VIEW,
  PERM_APP_LOGS_FUNNEL_CREATE,
  PERM_APP_LOGS_FUNNEL_UPDATE,
  PERM_APP_LOGS_FUNNEL_DELETE,
  PERM_APP_LOGS_PERFORMANCE_LOG_VIEW,
  PERM_APP_LOGS_ERROR_LOG_VIEW,
  PERM_APP_LOGS_JOURNEY_LOG_VIEW,
  PERM_APP_LOGS_ALERT_VIEW,
  PERM_APP_LOGS_ALERT_HANDLE,
  PERM_BOM_BOM_VIEW,
  PERM_BOM_BOM_CREATE,
  PERM_BOM_BOM_UPDATE,
  PERM_BOM_BOM_DELETE,
  PERM_BOM_BOM_APPROVE,
  PERM_BOM_BOM_FREEZE,
  PERM_BOM_BOM_OBSOLETE,
  PERM_BOM_BOM_IMPORT,
  PERM_BOM_SUBSTITUTE_MATERIAL_VIEW,
  PERM_BOM_SUBSTITUTE_MATERIAL_CREATE,
  PERM_BOM_SUBSTITUTE_MATERIAL_UPDATE,
  PERM_BOM_SUBSTITUTE_MATERIAL_DELETE,
  PERM_SYSTEM_DEPARTMENT_VIEW,
  PERM_SYSTEM_DEPARTMENT_CREATE,
  PERM_SYSTEM_DEPARTMENT_UPDATE,
  PERM_SYSTEM_DEPARTMENT_DELETE,
  PERM_SYSTEM_DEPARTMENT_SYNC,
  PERM_DINGTALK_AUTH_CONFIG,
  PERM_DINGTALK_AUTH_LOGIN,
  PERM_DINGTALK_ORGANIZATION_SYNC,
  PERM_EMPLOYEE_EMPLOYEE_VIEW,
  PERM_EMPLOYEE_EMPLOYEE_CREATE,
  PERM_EMPLOYEE_EMPLOYEE_UPDATE,
  PERM_EMPLOYEE_EMPLOYEE_DELETE,
  PERM_EMPLOYEE_EMPLOYEE_SYNC,
  PERM_EMPLOYEE_EMPLOYEE_BLACKLIST,
  PERM_EMPLOYEE_EMPLOYEE_RESIGN,
  PERM_EMPLOYEE_EMPLOYEE_REGULARIZE,
  PERM_EMPLOYEE_EMPLOYEE_LINK_USER,
  PERM_EMPLOYEE_EMPLOYEE_UNLINK_USER,
  PERM_EMPLOYEE_EMPLOYEE_SEND_CREDENTIALS,
  PERM_EQUIPMENT_EQUIPMENT_VIEW,
  PERM_EQUIPMENT_EQUIPMENT_EXPORT,
  PERM_EQUIPMENT_EQUIPMENT_CREATE,
  PERM_EQUIPMENT_EQUIPMENT_UPDATE,
  PERM_EQUIPMENT_EQUIPMENT_DELETE,
  PERM_EQUIPMENT_EQUIPMENT_BIND,
  PERM_EQUIPMENT_EQUIPMENT_OPERATE,
  PERM_EQUIPMENT_EQUIPMENT_FORCE_UNBIND,
  PERM_EQUIPMENT_EQUIPMENT_OPERATION_CONFIG,
  PERM_EQUIPMENT_INSPECTION_VIEW,
  PERM_EQUIPMENT_INSPECTION_CREATE,
  PERM_EQUIPMENT_INSPECTION_TEMPLATE_VIEW,
  PERM_EQUIPMENT_INSPECTION_TEMPLATE_CREATE,
  PERM_EQUIPMENT_INSPECTION_TEMPLATE_UPDATE,
  PERM_EQUIPMENT_INSPECTION_TEMPLATE_DELETE,
  PERM_EQUIPMENT_MAINTENANCE_VIEW,
  PERM_EQUIPMENT_MAINTENANCE_MANAGE,
  PERM_EQUIPMENT_REPAIR_VIEW,
  PERM_EQUIPMENT_REPAIR_CREATE,
  PERM_EQUIPMENT_REPAIR_UPDATE,
  PERM_EQUIPMENT_REPAIR_DELETE,
  PERM_EQUIPMENT_REPAIR_ASSIGN,
  PERM_EQUIPMENT_REPAIR_EXECUTE,
  PERM_EQUIPMENT_REPAIR_CANCEL,
  PERM_SYSTEM_FEEDBACK_VIEW,
  PERM_SYSTEM_FEEDBACK_REPLY,
  PERM_SYSTEM_FEEDBACK_UPDATE_STATUS,
  PERM_SYSTEM_FEEDBACK_DELETE,
  PERM_FILE_FILE_BUSINESS_UPLOAD,
  PERM_FILE_FILE_VIEW,
  PERM_FILE_FILE_UPLOAD,
  PERM_FILE_FILE_DOWNLOAD,
  PERM_FILE_FILE_UPDATE,
  PERM_FILE_FILE_DELETE,
  PERM_FILE_LOG_VIEW,
  PERM_FILE_VERSION_VIEW,
  PERM_FILE_VERSION_DOWNLOAD,
  PERM_FILE_VERSION_ROLLBACK,
  PERM_FILE_FOLDER_VIEW,
  PERM_FILE_FOLDER_CREATE,
  PERM_FILE_FOLDER_UPDATE,
  PERM_FILE_FOLDER_DELETE,
  PERM_FILE_FOLDER_PERMISSION,
  PERM_FILE_STORAGE_VIEW,
  PERM_INTEGRATION_MAPPING_RULE_VIEW,
  PERM_INTEGRATION_MAPPING_RULE_PREVIEW,
  PERM_INTEGRATION_MAPPING_RULE_CREATE,
  PERM_INTEGRATION_MAPPING_RULE_UPDATE,
  PERM_INTEGRATION_MAPPING_RULE_DELETE,
  PERM_INTEGRATION_OBJECT_PROFILE_VIEW,
  PERM_INTEGRATION_OBJECT_PROFILE_CREATE,
  PERM_INTEGRATION_OBJECT_PROFILE_UPDATE,
  PERM_INTEGRATION_OBJECT_PROFILE_DELETE,
  PERM_INTEGRATION_SYNC_JOB_VIEW,
  PERM_INTEGRATION_SYNC_JOB_CREATE,
  PERM_INTEGRATION_SYNC_JOB_MANAGE,
  PERM_INVENTORY_INVENTORY_VIEW,
  PERM_INVENTORY_INVENTORY_CREATE,
  PERM_INVENTORY_INVENTORY_UPDATE,
  PERM_INVENTORY_INVENTORY_DELETE,
  PERM_INVENTORY_INVENTORY_OUTBOUND,
  PERM_INVENTORY_INVENTORY_LOCK,
  PERM_INVENTORY_INVENTORY_UNLOCK,
  PERM_INVENTORY_INVENTORY_TRANSFER,
  PERM_INVENTORY_INVENTORY_IMPORT,
  PERM_INVENTORY_INVENTORY_EXPORT,
  PERM_INVENTORY_BATCH_PRINT,
  PERM_INVENTORY_INVENTORY_SIMPLE_INBOUND,
  PERM_INVENTORY_INVENTORY_SIMPLE_OUTBOUND,
  PERM_INVENTORY_INVENTORY_ADJUST,
  PERM_INVENTORY_INVENTORY_FREEZE,
  PERM_INVENTORY_INVENTORY_DELETE_FORCE,
  PERM_INVENTORY_INIT_VIEW,
  PERM_INVENTORY_INIT_CREATE,
  PERM_INVENTORY_INIT_UPDATE,
  PERM_INVENTORY_INIT_DELETE,
  PERM_INVENTORY_INIT_SUBMIT,
  PERM_INVENTORY_MATERIAL_ASSURANCE_VIEW,
  PERM_INVENTORY_MATERIAL_ASSURANCE_MANAGE,
  PERM_INVENTORY_MATERIAL_BORROW_VIEW,
  PERM_INVENTORY_MATERIAL_BORROW_MY,
  PERM_INVENTORY_MATERIAL_BORROW_CREATE,
  PERM_INVENTORY_MATERIAL_BORROW_RETURN,
  PERM_INVENTORY_MATERIAL_BORROW_CONFIRM,
  PERM_INVENTORY_MATERIAL_BORROW_CONFIRM_RETURN,
  PERM_INVENTORY_PICKING_STATISTICS_VIEW,
  PERM_INVENTORY_STOCKTAKING_VIEW,
  PERM_INVENTORY_STOCKTAKING_CREATE,
  PERM_INVENTORY_STOCKTAKING_EXECUTE,
  PERM_INVENTORY_STOCKTAKING_MANAGE,
  PERM_INVENTORY_WARNING_VIEW,
  PERM_INVENTORY_TRANSACTION_VIEW,
  PERM_INVENTORY_TRANSACTION_EXPORT,
  PERM_INVENTORY_TRANSACTION_APPROVE,
  PERM_INVENTORY_TRANSACTION_UPDATE_PENDING,
  PERM_IOT_GATEWAY_VIEW,
  PERM_IOT_GATEWAY_CONTROL,
  PERM_IOT_ALARM_VIEW,
  PERM_IOT_ALARM_HANDLE,
  PERM_IOT_STATISTICS_VIEW,
  PERM_IOT_DISCOVERED_DEVICE_VIEW,
  PERM_IOT_DISCOVERED_DEVICE_BIND,
  PERM_IOT_DISCOVERED_DEVICE_IGNORE,
  PERM_IOT_VIEW_ALL,
  PERM_IOT_VENDOR_VIEW,
  PERM_IOT_VENDOR_CREATE,
  PERM_IOT_VENDOR_UPDATE,
  PERM_IOT_VENDOR_DELETE,
  PERM_LOGISTICS_ORDER_VIEW,
  PERM_LOGISTICS_ORDER_CREATE,
  PERM_LOGISTICS_ORDER_UPDATE,
  PERM_LOGISTICS_ORDER_DELETE,
  PERM_LOGISTICS_ORDER_REVIEW,
  PERM_LOGISTICS_PROVIDER_VIEW,
  PERM_LOGISTICS_PROVIDER_CREATE,
  PERM_LOGISTICS_PROVIDER_UPDATE,
  PERM_LOGISTICS_PROVIDER_DELETE,
  PERM_LOGISTICS_SETTLEMENT_VIEW,
  PERM_LOGISTICS_SETTLEMENT_CREATE,
  PERM_LOGISTICS_SETTLEMENT_UPDATE,
  PERM_LOGISTICS_SETTLEMENT_DELETE,
  PERM_LOGISTICS_SETTLEMENT_IMPORT,
  PERM_LOGISTICS_SETTLEMENT_CONFIRM,
  PERM_LOGISTICS_SETTLEMENT_PAY,
  PERM_MANAGEMENT_REPORTS_VIEW,
  PERM_MATERIAL_MATERIAL_VIEW,
  PERM_MATERIAL_MATERIAL_CREATE,
  PERM_MATERIAL_MATERIAL_UPDATE,
  PERM_MATERIAL_MATERIAL_DELETE,
  PERM_MATERIAL_MATERIAL_IMPORT,
  PERM_MATERIAL_MATERIAL_EXPORT,
  PERM_MATERIAL_MATERIAL_CONVERT,
  PERM_MATERIAL_MATERIAL_BATCH_CONVERT,
  PERM_NOTIFICATION_ADMIN_VIEW,
  PERM_NOTIFICATION_ADMIN_MONITOR,
  PERM_NOTIFICATION_ADMIN_RETRY,
  PERM_NOTIFICATION_ADMIN_CREATE,
  PERM_NOTIFICATION_ADMIN_SEND,
  PERM_NOTIFICATION_ADMIN_BROADCAST,
  PERM_NOTIFICATION_ADMIN_UPDATE,
  PERM_NOTIFICATION_ADMIN_DELETE,
  PERM_NOTIFICATION_ADMIN_SYNC,
  PERM_NOTIFICATION_USER_VIEW,
  PERM_NOTIFICATION_USER_UPDATE,
  PERM_NOTIFICATION_USER_DELETE,
  PERM_NOTIFICATION_SYSTEM_RULE_VIEW,
  PERM_NOTIFICATION_SYSTEM_RULE_UPDATE,
  PERM_NOTIFICATION_SYSTEM_RULE_DELETE,
  PERM_OEE_CYCLE_TIME_VIEW,
  PERM_OEE_CYCLE_TIME_CREATE,
  PERM_OEE_CYCLE_TIME_UPDATE,
  PERM_OEE_CYCLE_TIME_DELETE,
  PERM_OEE_DASHBOARD_VIEW,
  PERM_OEE_DASHBOARD_CALCULATE,
  PERM_OEE_DASHBOARD_SYNC_ANDON,
  PERM_OEE_DOWNTIME_REASON_VIEW,
  PERM_OEE_DOWNTIME_REASON_CREATE,
  PERM_OEE_DOWNTIME_REASON_UPDATE,
  PERM_OEE_DOWNTIME_REASON_DELETE,
  PERM_OEE_DOWNTIME_RECORD_VIEW,
  PERM_OEE_DOWNTIME_RECORD_CREATE,
  PERM_OEE_DOWNTIME_RECORD_UPDATE,
  PERM_OEE_DOWNTIME_RECORD_END,
  PERM_OEE_DOWNTIME_RECORD_VERIFY,
  PERM_OEE_PLANNED_TIME_VIEW,
  PERM_OEE_PLANNED_TIME_CREATE,
  PERM_OEE_PLANNED_TIME_UPDATE,
  PERM_OEE_PLANNED_TIME_DELETE,
  PERM_OPERATION_OPERATION_VIEW,
  PERM_OPERATION_OPERATION_CREATE,
  PERM_OPERATION_OPERATION_UPDATE,
  PERM_OPERATION_OPERATION_DELETE,
  PERM_OPERATION_OPERATION_IMPORT,
  PERM_OPERATION_OPERATION_EXPORT,
  PERM_ORGANIZATION_FACTORY_VIEW,
  PERM_ORGANIZATION_FACTORY_CREATE,
  PERM_ORGANIZATION_FACTORY_UPDATE,
  PERM_ORGANIZATION_FACTORY_DELETE,
  PERM_ORGANIZATION_PRODUCTION_LINE_VIEW,
  PERM_ORGANIZATION_PRODUCTION_LINE_CREATE,
  PERM_ORGANIZATION_PRODUCTION_LINE_UPDATE,
  PERM_ORGANIZATION_PRODUCTION_LINE_DELETE,
  PERM_ORGANIZATION_PRODUCTION_LINE_IMPORT,
  PERM_ORGANIZATION_TEAM_VIEW,
  PERM_ORGANIZATION_TEAM_CREATE,
  PERM_ORGANIZATION_TEAM_UPDATE,
  PERM_ORGANIZATION_TEAM_DELETE,
  PERM_ORGANIZATION_WORKSHOP_VIEW,
  PERM_ORGANIZATION_WORKSHOP_CREATE,
  PERM_ORGANIZATION_WORKSHOP_UPDATE,
  PERM_ORGANIZATION_WORKSHOP_DELETE,
  PERM_ORGANIZATION_WORKSHOP_IMPORT,
  PERM_ORGANIZATION_WORKSTATION_VIEW,
  PERM_ORGANIZATION_WORKSTATION_CREATE,
  PERM_ORGANIZATION_WORKSTATION_UPDATE,
  PERM_ORGANIZATION_WORKSTATION_DELETE,
  PERM_ORGANIZATION_WORKSTATION_IMPORT,
  PERM_OUTSOURCE_DASHBOARD_VIEW,
  PERM_OUTSOURCE_ORDER_VIEW,
  PERM_OUTSOURCE_ORDER_CREATE,
  PERM_OUTSOURCE_ORDER_UPDATE,
  PERM_OUTSOURCE_ORDER_DELETE,
  PERM_OUTSOURCE_ORDER_SUBMIT,
  PERM_OUTSOURCE_ORDER_APPROVE,
  PERM_OUTSOURCE_ORDER_CANCEL,
  PERM_OUTSOURCE_ORDER_CLOSE,
  PERM_OUTSOURCE_ORDER_SETTLE,
  PERM_OUTSOURCE_RECEIVING_VIEW,
  PERM_OUTSOURCE_RECEIVING_CREATE,
  PERM_OUTSOURCE_RECEIVING_WAREHOUSE,
  PERM_OUTSOURCE_RECEIVING_QUALITY,
  PERM_OUTSOURCE_RECEIVING_EXCEPTION,
  PERM_OUTSOURCE_RETURN_VIEW,
  PERM_OUTSOURCE_RETURN_CREATE,
  PERM_OUTSOURCE_RETURN_WAREHOUSE,
  PERM_OUTSOURCE_SHIPMENT_VIEW,
  PERM_OUTSOURCE_SHIPMENT_CREATE,
  PERM_PLANNING_KIT_CHECK,
  PERM_PLANNING_MRP_CALCULATE,
  PERM_PLANNING_MRP_VIEW,
  PERM_PLANNING_ORDER_FULFILLMENT_VIEW,
  PERM_PRICING_CONFIG_VIEW,
  PERM_PRICING_CONFIG_CREATE,
  PERM_PRICING_CONFIG_UPDATE,
  PERM_PRICING_CONFIG_DELETE,
  PERM_PRICING_PRICE_VIEW,
  PERM_PRICING_PRICE_EXPORT,
  PERM_PRICING_PRICE_CREATE,
  PERM_PRICING_PRICE_UPDATE,
  PERM_PRICING_PRICE_DELETE,
  PERM_PRICING_PRICE_IMPORT,
  PERM_PRICING_WAGE_VIEW,
  PERM_PRICING_WAGE_EXPORT,
  PERM_PRICING_WAGE_SYNC,
  PERM_PRICING_WAGE_CONFIRM,
  PERM_PRICING_WAGE_SETTLE,
  PERM_PRICING_WAGE_VOID,
  PERM_PRICING_STATISTICS_VIEW,
  PERM_PRINTER_LOG_VIEW,
  PERM_PRINTER_LOG_CREATE,
  PERM_PRINTER_TEMPLATE_VIEW,
  PERM_PRINTER_TEMPLATE_CREATE,
  PERM_PRINTER_TEMPLATE_UPDATE,
  PERM_PRINTER_TEMPLATE_DELETE,
  PERM_PRINTER_PRINTER_VIEW,
  PERM_PRINTER_PRINTER_CREATE,
  PERM_PRINTER_PRINTER_UPDATE,
  PERM_PRINTER_PRINTER_DELETE,
  PERM_PROCESSROUTE_PROCESS_OPERATION_VIEW,
  PERM_PROCESSROUTE_PROCESS_OPERATION_CREATE,
  PERM_PROCESSROUTE_PROCESS_OPERATION_UPDATE,
  PERM_PROCESSROUTE_PROCESS_OPERATION_DELETE,
  PERM_PROCESSROUTE_PROCESS_OPERATION_IMPORT,
  PERM_PROCESSROUTE_PROCESS_ROUTE_VIEW,
  PERM_PROCESSROUTE_PROCESS_ROUTE_CREATE,
  PERM_PROCESSROUTE_PROCESS_ROUTE_UPDATE,
  PERM_PROCESSROUTE_PROCESS_ROUTE_DELETE,
  PERM_PROCESSROUTE_PROCESS_ROUTE_APPROVE,
  PERM_PROCESSROUTE_PROCESS_ROUTE_FREEZE,
  PERM_PROCESSROUTE_PROCESS_ROUTE_OBSOLETE,
  PERM_PROCESSROUTE_PROCESS_ROUTE_IMPORT,
  PERM_PROCESSROUTE_TEMPLATE_VIEW,
  PERM_PROCESSROUTE_TEMPLATE_CREATE,
  PERM_PROCESSROUTE_TEMPLATE_UPDATE,
  PERM_PROCESSROUTE_TEMPLATE_DELETE,
  PERM_PROCESSROUTE_TEMPLATE_GENERATE,
  PERM_PRODUCTION_DAILY_REPORT_VIEW,
  PERM_PRODUCTION_DAILY_REPORT_CREATE,
  PERM_PRODUCTION_DAILY_REPORT_UPDATE,
  PERM_PRODUCTION_DAILY_REPORT_DELETE,
  PERM_PRODUCTION_DAILY_REPORT_STATISTICS,
  PERM_PRODUCTION_DAILY_REPORT_NOTIFICATION_SWITCH,
  PERM_PRODUCTION_DAILY_REPORT_VIEW_ALL,
  PERM_PRODUCTION_MATERIAL_CONSUMPTION_VIEW,
  PERM_PRODUCTION_MATERIAL_CONSUMPTION_CREATE,
  PERM_PRODUCTION_MATERIAL_CONSUMPTION_DELETE,
  PERM_PRODUCTION_SCRAP_RATE_CALCULATE,
  PERM_PRODUCTION_PRODUCT_OPERATION_PROGRESS_VIEW,
  PERM_PRODUCTION_BATCH_VIEW,
  PERM_PRODUCTION_BATCH_TRACE,
  PERM_PRODUCTION_BATCH_REPRINT,
  PERM_PRODUCTION_BATCH_CONTAINER,
  PERM_PRODUCTION_DASHBOARD_VIEW,
  PERM_PRODUCTION_ORDER_VIEW,
  PERM_PRODUCTION_ORDER_CREATE,
  PERM_PRODUCTION_ORDER_UPDATE,
  PERM_PRODUCTION_ORDER_DELETE,
  PERM_PRODUCTION_ORDER_ACCEPT,
  PERM_PRODUCTION_ORDER_APPROVE,
  PERM_PRODUCTION_ORDER_START,
  PERM_PRODUCTION_ORDER_COMPLETE,
  PERM_PRODUCTION_ORDER_CANCEL,
  PERM_PRODUCTION_ORDER_DISPATCH,
  PERM_PRODUCTION_CAPACITY_VIEW,
  PERM_PRODUCTION_ORDER_OPERATION_CHANGE,
  PERM_PRODUCTION_REWORK_ORDER_VIEW,
  PERM_PRODUCTION_REWORK_ORDER_CREATE,
  PERM_PRODUCTION_REWORK_ORDER_UPDATE,
  PERM_PRODUCTION_REWORK_ORDER_DELETE,
  PERM_PRODUCTION_REWORK_ORDER_APPROVE,
  PERM_PRODUCTION_REWORK_ORDER_EXECUTE,
  PERM_PRODUCTION_SCRAP_ORDER_VIEW,
  PERM_PRODUCTION_SCRAP_ORDER_CREATE,
  PERM_PRODUCTION_SCRAP_ORDER_UPDATE,
  PERM_PRODUCTION_SCRAP_ORDER_DELETE,
  PERM_PRODUCTION_SCRAP_ORDER_APPROVE,
  PERM_PRODUCTION_WIP_VIEW,
  PERM_PRODUCTION_WORK_ORDER_VIEW,
  PERM_PRODUCTION_WORK_ORDER_CREATE,
  PERM_PRODUCTION_WORK_ORDER_UPDATE,
  PERM_PRODUCTION_WORK_ORDER_UPDATE_REMARK,
  PERM_PRODUCTION_WORK_ORDER_DELETE,
  PERM_PRODUCTION_WORK_ORDER_ACCEPT,
  PERM_PRODUCTION_WORK_ORDER_START,
  PERM_PRODUCTION_WORK_ORDER_PAUSE,
  PERM_PRODUCTION_WORK_ORDER_COMPLETE,
  PERM_PRODUCTION_WORK_ORDER_CANCEL,
  PERM_PRODUCTION_WORK_ORDER_BIND_EQUIPMENT,
  PERM_PRODUCTION_WORK_ORDER_PRINT_LABEL,
  PERM_PRODUCTION_WORK_ORDER_GENERATE_MULTI_LEVEL,
  PERM_PRODUCTION_WORK_ORDER_TREE,
  PERM_PRODUCTION_WORK_ORDER_OUTPUT_INBOUND,
  PERM_PRODUCTION_WORK_ORDER_TRANSFER,
  PERM_PRODUCTION_WORK_ORDER_OPERATION_CHANGE,
  PERM_PRODUCTION_WORK_REPORT_VIEW,
  PERM_PRODUCTION_WORK_REPORT_CREATE,
  PERM_PRODUCTION_WORK_REPORT_CANCEL,
  PERM_PRODUCTION_WORK_REPORT_DELETE,
  PERM_PRODUCTION_WORK_REPORT_FORCE_CANCEL,
  PERM_PRODUCTION_WORK_REPORT_VIEW_ALL,
  PERM_PURCHASE_DASHBOARD_VIEW,
  PERM_PURCHASE_ORDER_VIEW,
  PERM_PURCHASE_ORDER_CREATE,
  PERM_PURCHASE_ORDER_UPDATE,
  PERM_PURCHASE_ORDER_DELETE,
  PERM_PURCHASE_ORDER_APPROVE,
  PERM_PURCHASE_ORDER_CONFIRM,
  PERM_PURCHASE_ORDER_CANCEL,
  PERM_PURCHASE_ORDER_CLOSE,
  PERM_PURCHASE_ORDER_RECEIVE,
  PERM_PURCHASE_ORDER_RATE,
  PERM_PURCHASE_ORDER_STATISTICS,
  PERM_PURCHASE_ORDER_EXPORT,
  PERM_PURCHASE_ORDER_IMPORT,
  PERM_PURCHASE_RETURN_VIEW,
  PERM_PURCHASE_RETURN_CREATE,
  PERM_PURCHASE_RETURN_UPDATE,
  PERM_PURCHASE_RETURN_DELETE,
  PERM_PURCHASE_RETURN_SUBMIT,
  PERM_PURCHASE_RETURN_APPROVE,
  PERM_PURCHASE_RETURN_SHIP,
  PERM_PURCHASE_RETURN_COMPLETE,
  PERM_PURCHASE_RETURN_CANCEL,
  PERM_PURCHASE_RECEIVING_VIEW,
  PERM_PURCHASE_RECEIVING_UPLOAD,
  PERM_PURCHASE_RECEIVING_RECEIVE,
  PERM_PURCHASE_SUPPLIER_CLAIM_VIEW,
  PERM_PURCHASE_SUPPLIER_CLAIM_CREATE,
  PERM_PURCHASE_SUPPLIER_CLAIM_UPDATE,
  PERM_PURCHASE_SUPPLIER_CLAIM_DELETE,
  PERM_PURCHASE_SUPPLIER_CLAIM_CONFIRM,
  PERM_PURCHASE_SUPPLIER_CLAIM_PAY,
  PERM_PURCHASE_SUPPLIER_CLAIM_CLOSE,
  PERM_PURCHASE_SUPPLIER_CLAIM_REJECT,
  PERM_PURCHASE_SUPPLIER_VIEW,
  PERM_PURCHASE_SUPPLIER_CREATE,
  PERM_PURCHASE_SUPPLIER_UPDATE,
  PERM_PURCHASE_SUPPLIER_DELETE,
  PERM_PURCHASE_SUPPLIER_EXPORT,
  PERM_PURCHASE_SUPPLIER_IMPORT,
  PERM_PURCHASE_SUPPLIER_STATISTICS,
  PERM_PURCHASE_SUPPLIER_MATERIALS,
  PERM_PURCHASE_SUPPLIER_PERFORMANCE_VIEW,
  PERM_PURCHASE_SUPPLIER_PERFORMANCE_CALCULATE,
  PERM_PURCHASE_SUPPLIER_PERFORMANCE_UPDATE,
  PERM_QUALITY_AQL_VIEW,
  PERM_QUALITY_AQL_CREATE,
  PERM_QUALITY_AQL_UPDATE,
  PERM_QUALITY_AQL_DELETE,
  PERM_QUALITY_AQL_IMPORT,
  PERM_QUALITY_CAPA_VIEW,
  PERM_QUALITY_CAPA_CREATE,
  PERM_QUALITY_CAPA_UPDATE,
  PERM_QUALITY_CAPA_MANAGE,
  PERM_QUALITY_CAPA_DELETE,
  PERM_QUALITY_DEFECT_REASON_VIEW,
  PERM_QUALITY_DEFECT_REASON_CREATE,
  PERM_QUALITY_DEFECT_REASON_UPDATE,
  PERM_QUALITY_DEFECT_REASON_DELETE,
  PERM_QUALITY_EIGHT_D_LPA_VIEW,
  PERM_QUALITY_EIGHT_D_LPA_UPDATE,
  PERM_QUALITY_EIGHT_D_LPA_TRIGGER,
  PERM_QUALITY_8D_VIEW,
  PERM_QUALITY_8D_CREATE,
  PERM_QUALITY_8D_UPDATE,
  PERM_QUALITY_8D_DELETE,
  PERM_QUALITY_8D_MANAGE_TEAM,
  PERM_QUALITY_8D_LINK_NCR,
  PERM_QUALITY_8D_CLOSE,
  PERM_QUALITY_IQC_VIEW,
  PERM_QUALITY_IQC_EXECUTE,
  PERM_QUALITY_IQC_MATERIAL_VIEW,
  PERM_QUALITY_IQC_MATERIAL_UPDATE,
  PERM_QUALITY_IQC_CONTROL_MODE_UPDATE,
  PERM_QUALITY_INSPECTION_ITEM_VIEW,
  PERM_QUALITY_INSPECTION_ITEM_CREATE,
  PERM_QUALITY_INSPECTION_ITEM_UPDATE,
  PERM_QUALITY_INSPECTION_ITEM_DELETE,
  PERM_QUALITY_INSPECTION_ITEM_IMPORT,
  PERM_QUALITY_INSPECTION_ITEM_EXPORT,
  PERM_QUALITY_INSPECTION_SUMMARY_VIEW,
  PERM_QUALITY_INSPECTION_SUMMARY_REFRESH,
  PERM_QUALITY_TASK_VIEW,
  PERM_QUALITY_TASK_CREATE,
  PERM_QUALITY_TASK_EXECUTE,
  PERM_QUALITY_TEMPLATE_VIEW,
  PERM_QUALITY_TEMPLATE_CREATE,
  PERM_QUALITY_TEMPLATE_IMPORT,
  PERM_QUALITY_TEMPLATE_UPDATE,
  PERM_QUALITY_TEMPLATE_DELETE,
  PERM_QUALITY_LPA_ROSTER_VIEW,
  PERM_QUALITY_LPA_ROSTER_CREATE,
  PERM_QUALITY_LPA_ROSTER_UPDATE,
  PERM_QUALITY_LPA_ROSTER_DELETE,
  PERM_QUALITY_LPA_FINDING_VIEW,
  PERM_QUALITY_LPA_FINDING_UPDATE,
  PERM_QUALITY_LPA_FINDING_ASSIGN,
  PERM_QUALITY_LPA_FINDING_CLOSE,
  PERM_QUALITY_LPA_FINDING_VERIFY,
  PERM_QUALITY_LPA_FINDING_CREATE_NCR,
  PERM_QUALITY_LPA_LAYER_VIEW,
  PERM_QUALITY_LPA_LAYER_CREATE,
  PERM_QUALITY_LPA_LAYER_UPDATE,
  PERM_QUALITY_LPA_LAYER_DELETE,
  PERM_QUALITY_LPA_LIBRARY_VIEW,
  PERM_QUALITY_LPA_LIBRARY_CREATE,
  PERM_QUALITY_LPA_LIBRARY_UPDATE,
  PERM_QUALITY_LPA_LIBRARY_DELETE,
  PERM_QUALITY_LPA_SCHEDULE_VIEW,
  PERM_QUALITY_LPA_SCHEDULE_CREATE,
  PERM_QUALITY_LPA_SCHEDULE_UPDATE,
  PERM_QUALITY_LPA_SCHEDULE_DELETE,
  PERM_QUALITY_LPA_SCHEDULE_GENERATE,
  PERM_QUALITY_LPA_STATISTICS_VIEW,
  PERM_QUALITY_LPA_TASK_VIEW,
  PERM_QUALITY_LPA_CONFIG_MANAGE,
  PERM_QUALITY_LPA_TASK_CREATE,
  PERM_QUALITY_LPA_TASK_EXECUTE,
  PERM_QUALITY_LPA_TASK_CANCEL,
  PERM_QUALITY_LPA_TASK_REVIEW,
  PERM_QUALITY_LPA_TASK_CROSS_CHECK,
  PERM_QUALITY_LPA_TEMPLATE_VIEW,
  PERM_QUALITY_LPA_TEMPLATE_CREATE,
  PERM_QUALITY_LPA_TEMPLATE_UPDATE,
  PERM_QUALITY_LPA_TEMPLATE_DELETE,
  PERM_QUALITY_LPA_ITEM_CREATE,
  PERM_QUALITY_LPA_ITEM_UPDATE,
  PERM_QUALITY_LPA_ITEM_DELETE,
  PERM_QUALITY_MOBILE_VIEW,
  PERM_QUALITY_MOBILE_EXECUTE,
  PERM_QUALITY_NCR_VIEW,
  PERM_QUALITY_NCR_CREATE,
  PERM_QUALITY_NCR_UPDATE,
  PERM_QUALITY_NCR_APPROVE,
  PERM_QUALITY_NCR_EXECUTE,
  PERM_QUALITY_NCR_QRQC,
  PERM_QUALITY_QRQC_VIEW,
  PERM_QUALITY_QRQC_CREATE,
  PERM_QUALITY_QRQC_ANALYZE,
  PERM_QUALITY_QRQC_VERIFY,
  PERM_QUALITY_QRQC_REJECT,
  PERM_QUALITY_QRQC_CLOSE,
  PERM_QUALITY_DASHBOARD_VIEW,
  PERM_QUALITY_QUICK_INSPECTION_CREATE,
  PERM_QUALITY_QUICK_INSPECTION_VIEW,
  PERM_QUALITY_SELF_INSPECTION_VIEW,
  PERM_QUALITY_SELF_INSPECTION_CREATE,
  PERM_QUALITY_SELF_INSPECTION_UPDATE,
  PERM_QUALITY_SELF_INSPECTION_DELETE,
  PERM_SALES_CUSTOMER_VIEW,
  PERM_SALES_CUSTOMER_CREATE,
  PERM_SALES_CUSTOMER_UPDATE,
  PERM_SALES_CUSTOMER_DELETE,
  PERM_SALES_CUSTOMER_MATERIAL_SUPPLIER_VIEW,
  PERM_SALES_CUSTOMER_MATERIAL_SUPPLIER_CREATE,
  PERM_SALES_CUSTOMER_MATERIAL_SUPPLIER_UPDATE,
  PERM_SALES_CUSTOMER_MATERIAL_SUPPLIER_DELETE,
  PERM_SALES_CUSTOMER_MATERIAL_SUPPLIER_CHECK,
  PERM_SALES_ORDER_NUMBER_VIEW,
  PERM_SALES_ORDER_NUMBER_CREATE,
  PERM_SALES_ORDER_NUMBER_UPDATE,
  PERM_SALES_ORDER_VIEW,
  PERM_SALES_ORDER_CREATE,
  PERM_SALES_ORDER_UPDATE,
  PERM_SALES_ORDER_DELETE,
  PERM_SALES_ORDER_APPROVE,
  PERM_SALES_ORDER_CANCEL,
  PERM_SALES_SHIPMENT_VIEW,
  PERM_SALES_SHIPMENT_CREATE,
  PERM_SALES_SHIPMENT_CONFIRM,
  PERM_SALES_SHIPMENT_RECEIVE,
  PERM_SALES_SHIPMENT_CANCEL,
  PERM_SYSTEM_APP_VERSION_CHECK,
  PERM_SYSTEM_APP_VERSION_LOG_UPDATE,
  PERM_SYSTEM_CAPABILITY_PROFILE_VIEW,
  PERM_SYSTEM_CAPABILITY_PROFILE_CREATE,
  PERM_SYSTEM_CAPABILITY_PROFILE_UPDATE,
  PERM_SYSTEM_CAPABILITY_PROFILE_DELETE,
  PERM_SYSTEM_CUSTOMER_VERSION_VIEW,
  PERM_SYSTEM_CUSTOMER_VERSION_CREATE,
  PERM_SYSTEM_CUSTOMER_VERSION_UPDATE,
  PERM_SYSTEM_CUSTOMER_VERSION_DELETE,
  PERM_SYSTEM_LOGS_VIEW,
  PERM_SYSTEM_LOGS_DELETE,
  PERM_SYSTEM_MENU_VIEW,
  PERM_SYSTEM_MENU_CREATE,
  PERM_SYSTEM_MENU_UPDATE,
  PERM_SYSTEM_MENU_DELETE,
  PERM_SYSTEM_CONFIG_VIEW,
  PERM_SYSTEM_CONFIG_CREATE,
  PERM_SYSTEM_CONFIG_UPDATE,
  PERM_SYSTEM_CONFIG_DELETE,
  PERM_SYSTEM_TV_DEVICE_VIEW,
  PERM_SYSTEM_TV_DEVICE_MANAGE,
  PERM_TOOLING_FIXTURE_VIEW,
  PERM_TOOLING_FIXTURE_CREATE,
  PERM_TOOLING_FIXTURE_UPDATE,
  PERM_TOOLING_FIXTURE_DELETE,
  PERM_TOOLING_GAUGE_VIEW,
  PERM_TOOLING_GAUGE_CREATE,
  PERM_TOOLING_GAUGE_UPDATE,
  PERM_TOOLING_GAUGE_DELETE,
  PERM_TOOLING_GAUGE_BORROW,
  PERM_TOOLING_GAUGE_CALIBRATE,
  PERM_TOOLING_GAUGE_MOUNT,
  PERM_TOOLING_GAUGE_BLUETOOTH_BIND,
  PERM_TOOLING_GAUGE_BLUETOOTH_REBIND,
  PERM_TOOLING_MOLD_VIEW,
  PERM_TOOLING_MOLD_CREATE,
  PERM_TOOLING_MOLD_UPDATE,
  PERM_TOOLING_MOLD_DELETE,
  PERM_TOOLING_TOOL_VIEW,
  PERM_TOOLING_TOOL_CREATE,
  PERM_TOOLING_TOOL_UPDATE,
  PERM_TOOLING_TOOL_DELETE,
  PERM_TOOLING_TOOL_REPLACE,
  PERM_TOOLING_DASHBOARD_VIEW,
  PERM_TOOLING_APPLICATION_VIEW,
  PERM_TOOLING_APPLICATION_CREATE,
  PERM_TOOLING_APPLICATION_RETURN,
  PERM_TOOLING_APPLICATION_CANCEL,
  PERM_TOOLING_ALERT_VIEW,
  PERM_TOOLING_ALERT_HANDLE,
  PERM_TRACE_TRACE_VIEW,
  PERM_TRACE_TRACE_FORWARD,
  PERM_TRACE_TRACE_BACKWARD,
  PERM_TRACE_TRACE_FULL,
  PERM_TRACE_TRACE_LIFECYCLE,
  PERM_WAREHOUSE_LOCATION_VIEW,
  PERM_WAREHOUSE_LOCATION_CREATE,
  PERM_WAREHOUSE_LOCATION_UPDATE,
  PERM_WAREHOUSE_LOCATION_DELETE,
  PERM_WAREHOUSE_LOCATION_IMPORT,
  PERM_WAREHOUSE_WAREHOUSE_VIEW,
  PERM_WAREHOUSE_WAREHOUSE_CREATE,
  PERM_WAREHOUSE_WAREHOUSE_UPDATE,
  PERM_WAREHOUSE_WAREHOUSE_DELETE,
  PERM_WAREHOUSE_WAREHOUSE_IMPORT,
  PERM_WEB_LOGS_FUNNEL_VIEW,
  PERM_WEB_LOGS_FUNNEL_MANAGE,
  PERM_WEB_LOGS_DASHBOARD_VIEW,
  PERM_WEB_LOGS_ERROR_LOG_VIEW,
  PERM_WEB_LOGS_SOURCEMAP_RESOLVE,
  PERM_WEB_LOGS_PERFORMANCE_LOG_VIEW,
  PERM_WEB_LOGS_ALERT_VIEW,
  PERM_WEB_LOGS_ALERT_HANDLE,
  PERM_WEB_LOGS_SOURCEMAP_UPLOAD,
  PERM_WEB_LOGS_BEHAVIOR_LOG_VIEW,
  PERM_WEWORK_AUTH_LOGIN,
  PERM_WEWORK_AUTH_CONFIG,
  PERM_WEWORK_AUTH_BIND,
] as const;

/** API 权限类型 */
export type ApiPermission = typeof ALL_API_PERMISSIONS[number];
